{
  "currencyHint": {
    "disclaimer": "Approximate conversion at the current rate — for reference only, not a real transaction through Heirapsia."
  },
  "common": {
    "tapToReportBug": "Tap here to report a bug",
    "and": "and",
    "back": "‹ Back",
    "save": "Save",
    "cancel": "Cancel",
    "send": "Send",
    "confirm": "Confirm",
    "close": "Close",
    "done": "Done",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "yes": "Yes",
    "no": "No",
    "retry": "Try again",
    "or": "or",
    "delete": "Delete",
    "edit": "Edit",
    "share": "Share",
    "copy": "Copy",
    "copied": "Copied!",
    "search": "Search",
    "filter": "Filter",
    "all": "All",
    "none": "None",
    "optional": "optional",
    "unknown": "Unknown",
    "user": "User",
    "someone": "Someone",
    "userNumberFallback": "User #{{number}}",
    "ok": "OK",
    "info": "Info",
    "active": "Active",
    "inactive": "Inactive",
    "today": "Today",
    "expired": "Expired",
    "days": "days",
    "day": "day",
    "next": "Next →",
    "preview": "Preview",
    "continue": "Continue",
    "start": "Start ✓",
    "skip": "Skip",
    "understood": "Got it",
    "changedMind": "Never mind",
    "selectReason": "Select a reason (at least one):",
    "uploading": "Uploading…",
    "saving": "Saving…",
    "retake": "Retake",
    "new": "New",
    "view": "View →",
    "change": "Change",
    "help": "Help",
    "reject": "Reject",
    "accept": "Accept",
    "decline": "Decline",
    "remove": "Remove",
    "create": "Create",
    "public": "Public",
    "hidden": "Hidden",
    "uploaded": "✓ Uploaded",
    "complete": "Complete",
    "agreement": "Agreement",
    "noResults": "No results",
    "searchPlaceholder": "Search…",
    "tapToChange": "Tap to change",
    "you": "(you)",
    "selectedUser": "Selected user",
    "unknownUser": "Unknown user",
    "pdf": "PDF",
    "saving_changes": "Saving…",
    "uploading_logo": "Uploading…",
    "stepOf": "Step {{step}} of {{total}}",
    "select": "Select",
    "loadFailed": "Failed to load",
    "appName": "Χειραψία",
    "datePickerDone": "Select",
    "progress": "Progress",
    "level": "Level",
    "verified": "Verified",
    "tagline": "A digital handshake.",
    "valid": "VALID",
    "settlement": "SETTLEMENT",
    "communication": "Communication",
    "maybeLater": "Maybe later",
    "backTo": "Back to",
    "selectCountry": "Select country",
    "enjoyApp": "Enjoying Χειραψία?",
    "clear": "Clear",
    "datePickerPlaceholder": "Select date"
  },
  "language": {
    "select_title": "Choose your language",
    "select_subtitle": "You can change this later in Settings.",
    "greek": "Ελληνικά",
    "english": "English",
    "toggle_label": "App language"
  },
  "auth": {
    "error_invalidCredentials": "Wrong email or password.",
    "error_alreadyRegistered": "An account with this email already exists.",
    "error_passwordTooShort": "Password must be at least 6 characters.",
    "error_invalidEmail": "Invalid email address.",
    "error_emailNotConfirmed": "Please confirm your email first using the message you received. (Check spam/junk if you don't see it)",
    "error_codeExpired": "The code has expired. Request a new reset code.",
    "error_invalidResetCode": "Invalid reset code.",
    "error_invalidOrExpiredCode": "Invalid or expired code.",
    "error_samePassword": "The new password must be different from the old one.",
    "error_rateLimit": "Too many attempts. Try again shortly.",
    "login": {
      "subtitle": "Welcome back to Heirapsia. Sign in to your account.",
      "email": "Email",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "submit": "Sign in",
      "no_account": "Don't have an account?",
      "register_link": "Sign up",
      "notRegistered_title": "Looks like you're not registered yet!",
      "notRegistered_body": "Shall we sign you up?",
      "notRegistered_no": "No",
      "notRegistered_yes": "Yes"
    },
    "register": {
      "title": "Sign up",
      "subtitle": "Create your Heirapsia account.",
      "full_name": "Full name",
      "email": "Email",
      "password": "Password (at least 8 characters)",
      "confirm_password": "Confirm password",
      "submit": "Create account",
      "have_account": "Already have an account?",
      "login_link": "Sign in",
      "terms_agree": "I have read and accept the",
      "terms_link": "Terms of Service",
      "success_title": "Account created!",
      "success_body": "Check your email to confirm your account.",
      "consent": {
        "accept": "I accept the",
        "and": "and the",
        "terms": "Terms of Service",
        "privacy": "Privacy Policy"
      },
      "duplicate_email": {
        "title": "Already have an account?",
        "body": "An account with this email already exists.",
        "login": "Sign in"
      }
    },
    "forgot_password": {
      "title": "Reset password",
      "subtitle": "Enter your email and we'll send you instructions.",
      "email": "Email",
      "submit": "Send",
      "success": "Check your email for the reset link.",
      "back": "Back to sign in",
      "remembered": "Remember it?",
      "have_code": "I have a code"
    },
    "reset_password": {
      "title": "New password",
      "new_password": "New password",
      "submit": "Update password",
      "success": "Password updated. Please sign in again.",
      "code_label": "Reset code",
      "confirm_label": "Confirm new password",
      "subtitle_link": "Set your new password.",
      "subtitle_code": "Enter the 6-digit code you received by email and set a new password. (Check spam if you don't see it)",
      "code_error": "Enter the code from the email.",
      "resent_title": "Sent",
      "resent_body": "We sent you a new reset email. (Check spam if you don't see it)",
      "change_btn": "Change password",
      "resend_btn": "Resend email",
      "sending": "Sending…"
    },
    "action": {
      "login": "Sign in",
      "register": "Sign up"
    },
    "field": {
      "password": "Password",
      "confirmPassword": "Confirm password"
    }
  },
  "home": {
    "statsExplainTitle": "What do these mean?",
    "statsExplainRating": "⭐ Rating: the average of reviews you've received from other users.",
    "statsExplainReliability": "✅ Reliability: the percentage of your agreements that were completed normally, without a dispute.",
    "statsExplainLevel": "🏅 Level: goes up the more agreements you complete with good behavior.",
    "greeting": "Hello, {{name}}!",
    "greetingPrefix": "Hello,",
    "tab_label": "Home",
    "active_agreements": "Active agreements",
    "no_active": "You have no active agreements.",
    "ink_remaining": "Ink: {{count}} signatures",
    "search_placeholder": "Search user...",
    "notifications_empty": "No notifications.",
    "notifications_mark_all": "Mark all as read",
    "announcements": "Circle announcements",
    "no_announcements": "No announcements.",
    "level": "Level {{level}}",
    "completed_agreements": "{{count}} completed agreements",
    "betaBanner": "Test version — profiles and agreements will be cleared before official launch.",
    "myAgreements": "Agreements",
    "incomingOffers": "Incoming Offers",
    "myOffers": "Send Offer",
    "markAllRead": "Mark all as read",
    "noNotifications": "No notifications",
    "noNotificationsBody": "You'll be notified of activity here.",
    "walletInfo": "Each agreement uses 1 ink from your pen.",
    "emptyWalletTitle": "Your pen is empty",
    "emptyWalletLink": "Refill ink",
    "freeAgreements": "Free agreements remaining",
    "platformStat": "Agreements completed on Heirapsia",
    "freeModalTitle": "Free agreements",
    "freeModalBody": "Every new user gets free agreement signatures.",
    "freeModalDismiss": "Got it!",
    "circleLabel": "in my circle",
    "circlePeople": "people",
    "myCircle": "My Circle",
    "myProfile": "My profile",
    "notifications": "Notifications",
    "unreadChat": "You have an unread message",
    "chat": "Messages",
    "noChats": "No messages yet.",
    "searchingUserId": "Searching UserID…",
    "action": {
      "newAgreement": "New agreement"
    },
    "level_max": "🏆 Legend — Maximum level!",
    "level_progress": "{{count}} more agreements to level up!",
    "defaultUserName": "User",
    "shareProfileTitle": "{{name}} on Heirapsia",
    "shareProfileMessage": "Check out my profile on Heirapsia{{rating}}",
    "news": "Newspaper",
    "findProfessionals": "Find professionals",
    "findClients": "Client Requests",
    "promoteProfile": "Promote professional profile",
    "promoteProfileActive": "Active promotion · {{rate}} ink/day",
    "promotePrivateBody": "Profile promotion is only available for public profiles.",
    "promoteMakePublic": "Make it public & promote",
    "nearbyRequestsHint_one": "{{count}} request near you!",
    "nearbyRequestsHint_other": "{{count}} requests near you!",
    "nearbyProfessionalsHint": "{{count}} near you!",
    "section_discover": "Discover",
    "section_agreements": "Agreements",
    "section_proTools": "Professional Tools",
    "activeAgreementsCaption_one": "{{count}} active",
    "activeAgreementsCaption_other": "{{count}} active",
    "requests": "Requests",
    "reportBug": "To report bugs or suggest new features, tap here!",
    "walletHasInkPrefix": "You have ink for",
    "walletHasInkBold": "{{count}} signatures",
    "walletHasInkSuffix": "left",
    "walletEmpty": "Your ink ran out from all those signatures! You can still accept offers for free. ",
    "freeCount_one": "You have {{count}} free agreement!",
    "freeCount_other": "You have {{count}} free agreements!",
    "newAgreementHint_ink": "Ink for {{count}} signatures.",
    "noInkHint": "✒️ Out of signature ink! - Refill it",
    "juryDutySelected": "🧑‍⚖️ You've been drawn as a juror for a dispute!",
    "juryDutyCountdownHours": "You have {{hours}}h {{minutes}}m to decide before it goes to another juror.",
    "juryDutyCountdownMinutes": "You have {{minutes}} minutes to decide before it goes to another juror.",
    "juryDutyExpiringNow": "Expiring any moment — tap to vote.",
    "newAgreementHint_free_one": "{{count}} free signature!",
    "newAgreementHint_free_other": "{{count}} free signatures!",
    "platformStatFull": "{{count}} agreements have been signed on Heirapsia",
    "platformStatOffers": "{{count}} offers have been sent via Heirapsia",
    "platformStatUsers": "{{count}} people trust Heirapsia",
    "platformStatDisputes": "{{count}} disputes resolved fairly",
    "platformStatProfessionals": "{{count}} professionals are already here",
    "platformStatEur": "€{{count}} worth of agreements via Heirapsia",
    "freeModalIntroPrefix": "Every agreement on Heirapsia costs",
    "freeModalIntroBold": "1 ink",
    "freeModalIntroSuffix": ". You can earn free agreements in the following ways:",
    "freeModalWelcomeTitle": "Welcome bonus",
    "freeModalWelcomeDesc": "You get 45 free agreements as soon as you sign up on Heirapsia — enough to cover the whole \"New\" tier.",
    "freeModalLevelUpTitle": "Level up",
    "freeModalLevelUpDesc": "Every time you level up you earn +5 free agreements. Level up by completing agreements!",
    "offersWaiting_one": "{{count}} offer awaiting your response",
    "offersWaiting_other": "{{count}} offers awaiting your response",
    "firstOfferAlertTitle": "Ready to go professional!",
    "firstOfferAlertBody": "Want to create your first offer now?",
    "later": "Later",
    "createOffer": "Create offer",
    "loadOlder": "Load older",
    "coach_profile_title": "Your profile",
    "coach_profile_text": "See your rating and verify your identity here.",
    "coach_circle_title": "My Circle",
    "coach_circle_text": "This is your Circle — the contacts you trust. Connect people you know to build your network.",
    "coach_search_title": "Find users",
    "coach_search_text": "Search for people and view their public profiles.",
    "coach_agreements_title": "Your agreements",
    "coach_agreements_text": "All your agreements here — with a notification when your approval is needed.",
    "coach_new_title": "New agreement",
    "coach_new_text": "Start a new agreement — it's free!"
  },
  "agreements": {
    "tab_label": "Agreements",
    "type_label": "Agreement type",
    "type_one_off": "With deadline",
    "type_one_off_sub": "One job, specific deadline",
    "type_ongoing": "Ongoing",
    "type_ongoing_sub": "Open-ended collaboration",
    "type_fixed_term": "From-To",
    "type_fixed_term_sub": "Fixed period",
    "title": "Agreements",
    "new": "New Agreement",
    "all": "All",
    "active": "Active",
    "pending": "Pending",
    "completed": "Completed",
    "status": {
      "pending": "Pending",
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "cancelled_mutual": "Cancelled mutually",
      "cancelled_unilateral": "Unilateral cancellation",
      "terminated": "Terminated",
      "disputed": "Disputed",
      "frozen": "Frozen",
      "draft": "Draft",
      "cancel_requested": "Cancellation requested",
      "withdrawn": "Withdrawn",
      "pending_completion": "Pending completion",
      "cancelled_unsigned_timeout": "Cancelled - no response",
      "overdue": "Deadline passed"
    },
    "typeLabel": {
      "one_off": "One-off",
      "ongoing": "Long-term"
    },
    "type": {
      "service": "Service",
      "sale": "Sale",
      "loan": "Loan",
      "rental": "Rental",
      "other": "Other"
    },
    "role": {
      "creator": "Creator",
      "counterparty": "Counterparty"
    },
    "fields": {
      "title": "Title",
      "description": "Description",
      "amount": "Amount (€)",
      "due_date": "Due date",
      "type": "Agreement type"
    },
    "agree_btn": "I Agree",
    "sign_btn": "Sign",
    "withdraw_btn": "Withdraw",
    "cancel_btn": "Cancel agreement",
    "dispute_btn": "Dispute",
    "complete_btn": "Complete",
    "edit_btn": "Edit",
    "share_btn": "Share",
    "qr_btn": "QR Code",
    "pdf_btn": "PDF Certificate",
    "review_btn": "Review",
    "both_agreed": "Both parties agreed",
    "waiting_other": "Waiting for the other party",
    "waiting_you": "Your agreement is required",
    "signature_locked": "Your signature pen is locked — you need more ink.",
    "error_sign": "Error while signing.",
    "error_load": "Could not load agreement.",
    "empty": "No agreements found.",
    "new_title": "New Agreement",
    "with": "with {{name}}",
    "draft_saved": "Draft saved.",
    "confirm_withdraw": "Are you sure you want to withdraw this agreement?",
    "confirm_cancel": "Are you sure you want to cancel this agreement?",
    "notFound": "Agreement not found.",
    "inviteSuffix": "(invite)",
    "openDuration": "Open duration",
    "noExpiry": "No expiry",
    "noCounterparty": "No counterparty",
    "signedByBoth": "✓ Digitally signed by both parties",
    "signatureCode": "Signature code:",
    "signedDigitally": "✔ Digitally signed",
    "pdfAvailableAfterSigning": "Available after mutual signing",
    "availableSoon": "Available soon",
    "availableInHours": "Available in {{hours}} hours",
    "cooldownTitle": "24-hour cooldown",
    "cooldownBody": "You can send a new agreement to this person in {{time}}.",
    "cancelRequestedWaiting": "You requested cancellation. Waiting for {{name}}'s response…",
    "cancelWaiting": "Waiting for cancellation response…",
    "agreedWaitingOther": "You agreed ✓ — waiting for {{name}}…",
    "completionRequestedWaiting": "You requested completion. Waiting for {{name}}'s confirmation…",
    "paymentDeclaredWaiting": "You declared payment. Waiting for {{name}}'s confirmation…",
    "paymentDeclaredQuestion": "{{name}} declares payment — do you confirm receipt?",
    "completionConfirmQuestion": "{{name}} requests completion — do you confirm?",
    "cancelRequestQuestion": "{{name}} requests cancellation — do you accept?",
    "cancelResponse": "Response:",
    "freeSigningNotice": "You are signing this agreement for free.",
    "signedFreeWaiting": "You signed for free ✓ — waiting for {{name}}…",
    "agreedWaiting": "You agreed ✓ — waiting for {{name}}…",
    "invitePendingNotice": "The invite was sent. Waiting for the other party to register.",
    "section_terms": "Commitment & Agreement Terms",
    "section_signatures": "Digital Signatures",
    "section_cancelReasons": "Cancellation reasons",
    "section_charges": "Charges",
    "field_title": "Title",
    "field_counterparty": "Counterparty",
    "field_creator": "Creator",
    "field_date": "Date",
    "field_percent": "Percentage",
    "field_amount": "Amount",
    "field_dateType": "Date type",
    "field_expiryDate": "Expiry / milestone date (optional)",
    "field_termsOptional": "Commitment terms (optional)",
    "templatesLabel": "Commitment text template",
    "templateFreeText": "Free text",
    "field_percentOptional": "Share percentage (optional)",
    "field_amountOptional": "Agreement amount (optional)",
    "type_withMilestone": "With milestone",
    "type_noMilestone": "No milestone",
    "action_editDraft": "Edit draft",
    "action_send": "Send",
    "action_saveDraft": "Save to Drafts",
    "action_shareLink": "Share link",
    "action_resendInviteLink": "Resend invite link",
    "action_withdrawProposal": "Withdraw proposal",
    "action_requestCompletion": "Request Completion",
    "action_reportDispute": "Report Dispute",
    "action_exportPdf": "Print / Save PDF",
    "action_deleteDraft": "Delete draft",
    "action_agreeCancellation": "Accept cancellation",
    "action_rejectCancellation": "Reject cancellation",
    "action_signFree": "Agree & Sign (Free)",
    "action_signInk": "Agree & Sign (-1 ink)",
    "action_sign": "Agree & Sign",
    "action_signatureRequired": "Your signature is required",
    "action_send_agreement": "Send agreement",
    "confirm_accept_title": "Sign Agreement",
    "confirm_accept_message": "By signing, you agree to the terms of this agreement.",
    "confirm_accept_label": "Sign",
    "confirm_reject_title": "Reject Agreement",
    "confirm_reject_message": "Are you sure you want to reject this agreement?",
    "confirm_reject_label": "Reject",
    "confirm_withdraw_title": "Withdraw Agreement",
    "confirm_withdraw_message": "The agreement will be moved to drafts. The other party will no longer see it.",
    "confirm_withdraw_label": "Withdraw",
    "confirm_complete_title": "Complete Agreement",
    "confirm_complete_message": "Are you sure you want to mark this agreement as completed?",
    "confirm_complete_label": "Complete",
    "confirm_cancel_request_title": "Request Cancellation",
    "confirm_cancel_request_message": "You'll request cancellation. The other party must agree.",
    "confirm_cancel_request_label": "Request",
    "confirm_cancel_agree_title": "Accept Cancellation",
    "confirm_cancel_agree_message": "The agreement will be mutually cancelled.",
    "confirm_cancel_agree_label": "Accept",
    "confirm_request_completion_title": "Request Completion",
    "confirm_request_completion_message": "You'll ask the other party to confirm completion.",
    "confirm_request_completion_label": "Request",
    "confirm_confirm_completion_title": "Confirm Completion",
    "confirm_confirm_completion_message": "Are you sure you want to confirm completion?",
    "confirm_confirm_completion_label": "Confirm",
    "confirm_reject_completion_title": "Reject Completion",
    "confirm_reject_completion_message": "The completion request will be rejected.",
    "confirm_reject_completion_label": "Reject",
    "confirm_declare_payment_title": "Declare Payment",
    "confirm_declare_payment_message": "You'll declare that you've made payment.",
    "confirm_declare_payment_label": "Declare",
    "confirm_confirm_payment_title": "Confirm Payment",
    "confirm_confirm_payment_message": "You'll confirm you've received payment.",
    "confirm_confirm_payment_label": "Confirm",
    "confirm_reject_payment_title": "Reject Payment",
    "confirm_reject_payment_message": "You'll reject the payment declaration.",
    "confirm_reject_payment_label": "Reject",
    "payment_status_charged": "Charged",
    "payment_status_cancelled": "Cancelled",
    "payment_status_authorized": "Authorized",
    "filter_all": "All",
    "filter_needsAction": "Action needed",
    "filter_active": "Active",
    "filter_completed": "Completed",
    "filter_cancelled": "Cancelled",
    "filter_drafts": "Drafts",
    "expiry_none": "No expiry",
    "expiry_due": "Due date",
    "expiry_delivery": "Delivery date",
    "expiry_milestone": "Milestone",
    "empty_noResults": "No results",
    "empty_noAgreements": "No agreements yet",
    "empty_allGood": "✅ All good!",
    "empty_noneHere": "No agreements here",
    "delete_draft_title": "Delete draft",
    "delete_draft_message": "This will permanently delete the draft.",
    "role_with": "With",
    "role_from": "From",
    "nav_back": "‹ Agreements",
    "sent_title": "Sent",
    "sent_body": "The agreement was sent.",
    "sent_invite_body": "The agreement was sent and an invitation was emailed to {{email}}.",
    "too_early_title": "Too early",
    "too_early_body": "A short time must pass after signing before the agreement can be completed.",
    "too_early_body_withTime": "The agreement can be completed after {{time}} (3 hours after signing — protection against rushed completion).",
    "completion_requested": "Completion request sent.",
    "completion_rejected": "Completion request rejected.",
    "payment_rejected": "Payment declaration rejected.",
    "search_placeholder": "Search title or person…",
    "share_message": "Check out and accept this agreement on Heirapsia:",
    "share_invite_code": "\nAccess code: {{code}}",
    "cooldown_chip": "Available soon",
    "cooldown_chip_hours": "Available in {{hours}}h",
    "waiting_my_signature": "You agreed ✓ — waiting for {{name}}…",
    "review_summary_title": "Agreement summary",
    "completedTitle": "Agreement Completed!",
    "completedSub": "You can now review your collaboration.",
    "coach1_title": "Agreement title",
    "coach1_text": "A short, descriptive name. E.g. \"Website development\", \"Equipment rental\". It'll be visible to both parties.",
    "coach2_title": "Milestone date",
    "coach2_text": "Optional. When the date arrives, both of you get notified — nothing happens automatically. You decide what to do.",
    "coach3_title": "Counterparty",
    "coach3_text": "The person who will sign with you. Search by their name if they're on Heirapsia, or enter an email to invite them.",
    "coach4_title": "Amount / Percentage",
    "coach4_text": "Optional. Once the agreement starts, you can log payments directly from its page.",
    "coach5_title": "Commitment terms",
    "coach5_text": "Describe what you're agreeing to. E.g. \"Party A delivers X by date Y; Party B pays €Z\". The clearer it is, the stronger the protection.",
    "errorTitleRequired": "Give the agreement a title.",
    "errorCounterpartyRequired": "Enter the counterparty's name or email.",
    "errorStartDateRequired": "Select a start date.",
    "errorEndDateRequired": "Select an end date.",
    "errorEndAfterStart": "The end date must be after the start date.",
    "errorInvalidAmount": "Invalid amount.",
    "errorSuspended": "Your account has been suspended. Contact hello@heirapsia.gr.",
    "errorFrozen": "Your account is temporarily suspended pending a content review. Try again later.",
    "errorDailyLimit": "You've reached your daily limit of new agreements for your level ({{limit}}/day). Try again tomorrow.",
    "errorSelfAgreement": "You can't make an agreement with yourself.",
    "errorCreateFailed": "Failed to create agreement.",
    "errorSaveDraftFailed": "Failed to save draft.",
    "errorSaveFailed": "Save failed.",
    "untitled": "Untitled",
    "selectedUserFallback": "Selected user",
    "saveDraftPromptTitle": "Save as draft?",
    "saveDraftPromptBody": "You haven't finished the agreement. It won't be sent to anyone — you can finish it later from Drafts.",
    "discard": "Discard",
    "newAgreementTitle": "New Agreement",
    "templateBusinessTermsClause": "{{name}} has read and accepts the terms and conditions of {{business}}.",
    "partyModeSubtitle": "Between how many people?",
    "twoPartyTitle": "Between 2 people",
    "twoPartySubtitle": "The classic flow — you and one counterparty.",
    "multiPartyTitle": "Multiple people",
    "multiPartySubtitle": "3 or more people, with participation shares (prototype feature).",
    "wizardStep1Title": "Agreement details",
    "wizardStep2Title": "Amount & Terms",
    "wizardStep3Title": "Review",
    "wizardStep1Subtitle": "Give a title, choose a counterparty and a date.",
    "wizardStep2Subtitle": "Optional amount and commitment details.",
    "wizardStep3Subtitle": "Check the details before you send.",
    "titlePlaceholder": "e.g. Equipment rental",
    "counterpartyPlaceholder": "Name or email…",
    "counterpartyInviteHint": "If they're not registered, they'll get an email invite.",
    "counterpartySearchHint": "Type a name to search, or @ for email.",
    "unregisteredNamePlaceholder": "Counterparty name (optional)",
    "milestoneDateLabel": "Milestone date (optional)",
    "milestoneDateHintSet": "Both parties get notified — nothing happens automatically.",
    "milestoneDateHintEmpty": "No milestone: open-ended deadline.",
    "startDateLabel": "Start date",
    "endDateLabel": "End date",
    "fixedTermDurationHint": "Duration: {{days}} days. When it ends, both of you will be asked whether you want to renew.",
    "ongoingHint": "Open-ended collaboration with no predetermined end.",
    "amountPercentLabel": "Share percentage (optional)",
    "amountEurLabel": "Agreement amount (optional)",
    "amountPercentPlaceholder": "e.g. 10",
    "amountEurPlaceholder": "e.g. 150",
    "amountPercentHint": "For share agreements — e.g. % of company or % of fee.",
    "amountEurHint": "The agreement's value in {{currency}}.",
    "termsPlaceholder": "e.g. The seller delivers… the buyer pays…",
    "reviewTypeLabel": "Type",
    "reviewPeriodLabel": "Period",
    "reviewOpenDuration": "Open-ended",
    "submitHint": "Once you send it, the counterparty will get a notification to sign. The 1-ink charge only applies once both of you agree.",
    "cooldown12Title": "12-hour cooldown",
    "cooldown12Body": "You've already created an agreement together in the last 12 hours.\nYou can send again:",
    "expiryLabelPayment": "Payment date",
    "multi_userFallback": "User",
    "multi_emailInviteLabel": "{{email}} (invite)",
    "multi_maxPartiesError": "Maximum 6 additional parties in this prototype.",
    "multi_duplicatePartyError": "This person/email is already in the list.",
    "multi_invalidEmailError": "Enter a valid email.",
    "multi_titleTooShort": "Give a title of at least 3 characters.",
    "multi_needTwoParties": "At least 2 additional parties are needed.",
    "multi_amountRequired": "Fill in the total amount to split it in €.",
    "multi_percentMismatch": "Percentages must add up to 100% (currently: {{total}}%).",
    "multi_amountMismatch": "Amounts must add up to the total amount ({{splitTotal}}€, currently: {{total}}€).",
    "multi_createFailed": "Creation failed.",
    "multi_incompleteTitle": "Incomplete agreement",
    "multi_incompleteBody": "{{msg}}\n\nIt can't be saved as a draft as is. Do you want to discard it?",
    "multi_continueEditing": "Continue editing",
    "multi_saveDraftPromptBody": "It won't be sent to anyone now — you can finish and send it later from Drafts.",
    "multi_wizardTitle": "Multi-Party Agreement",
    "multi_wizardReviewTitle": "Review",
    "multi_wizardFormSubtitle": "Prototype feature — add 2+ people and set a split.",
    "multi_wizardReviewSubtitle": "Check the details before saving as a draft.",
    "multi_prototypeNotice": "Prototype feature. Reviews/reminders work in a simplified way for now.",
    "multi_titleFieldLabel": "Agreement title",
    "multi_titleFieldPlaceholder": "e.g. Group trip — accommodation expenses",
    "multi_termsFieldLabel": "Terms / Description (optional)",
    "multi_termsFieldPlaceholder": "Commitment description",
    "multi_amountFieldLabelRequired": "Total amount € (required)",
    "multi_amountFieldLabelOptional": "Total amount € (optional)",
    "multi_amountFieldPlaceholder": "e.g. 300",
    "multi_sectionTitle": "Parties & Split",
    "multi_lockHint": "Tap the lock next to a percentage to lock it — it won't change when you adjust the rest.",
    "multi_percentMode": "Percent %",
    "multi_amountMode": "Amount €",
    "multi_youCreator": "You (creator)",
    "multi_unlockShare": "Unlock share",
    "multi_lockShare": "Lock share",
    "multi_totalLabel": "Total: {{total}}{{unit}} {{ofTotal}}",
    "multi_addPersonLabel": "Add person (+)",
    "multi_searchPlaceholder": "Search name…",
    "multi_inviteResultText": "Invite \"{{query}}\" by email (no account yet)",
    "multi_reviewButton": "Review",
    "multi_reviewTotalAmount": "Total amount: {{amount}}€",
    "multi_reviewNotice": "This will be saved as a draft. It won't be sent to anyone until you explicitly tap \"Send\" from the agreement page.",
    "multi_back": "Back",
    "multi_saveAsDraft": "Save as Draft",
    "listLoadFailed": "Failed to load.",
    "groupPending": "Pending",
    "groupActive": "Active",
    "groupArchive": "Archive",
    "emptySearchBody": "No agreement found for \"{{query}}\".",
    "emptyAllBody": "Create your first digital agreement.",
    "emptyNeedsActionBody": "There's no pending action right now.",
    "emptyOtherBody": "Try another filter or pull down to refresh.",
    "fromOfferChip": "From offer",
    "daysAbbrev": "{{count}}d",
    "editSubtitle": "Update the terms and resend.",
    "editErrorStartDateRequired": "Select a start date.",
    "editErrorEndDateRequired": "Select an end date.",
    "editErrorEndAfterStart": "The end date must be after the start date.",
    "editErrorSaveFailed": "Save failed.",
    "editTypeLabel": "Type",
    "editTypeOneOff": "One-off",
    "editTypeOngoing": "Ongoing",
    "editTypeFixedTerm": "From-To",
    "editStartDateLabel": "Start date",
    "editEndDateLabel": "End date",
    "editDurationHint": "Duration: {{days}} days.",
    "editOngoingHint": "Open-ended collaboration with no predetermined end.",
    "editPartiesLabel": "Parties & shares",
    "editYouCreator": "You (creator)",
    "editUserFallback": "User",
    "editPartiesHint": "Parties and shares can't be changed here — only title, amount, terms and dates.",
    "editMultiAmountLabel": "Total amount € (optional)",
    "editAmountPercentPlaceholder": "e.g. 10",
    "editCounterpartyShareHint": "The other party will have {{percent}}%.",
    "editAmountEurPlaceholder": "e.g. 150",
    "editExpiryLabelAgreementEnd": "Agreement end",
    "editExpiryLabelDelivery": "Project delivery",
    "editExpiryLabelPaymentDeadline": "Payment deadline",
    "editExpiryLabelStartDate": "Start date",
    "editExpiryLabelOther": "Other"
  },
  "agreementDetail": {
    "insufficientInkTitle": "Not enough ink",
    "insufficientInkBody": "You don't have enough ink or free signatures to continue. Top up your ink to proceed.",
    "newStateBubble": "New status - Tap here!",
    "percentSplitValue": "{{creatorName}}: {{creatorPercent}}% · {{counterpartyName}}: {{counterpartyPercent}}%",
    "staleActionState": "The agreement's status changed in the meantime (e.g. it was already responded to). Refreshing the data — try again if needed.",
    "dealOwnerLabel": "Deal owner",
    "dealOwnerValue": "{{name}}, from {{business}}",
    "reliabilityChangeTitle": "Reliability score",
    "reliabilityChangeBody": "Your reliability {{sign}}{{diff}}% — from {{before}}% to {{after}}%.",
    "pdfOutdated": "Updated",
    "sendFailed": "Sending failed.",
    "pdfExportFailed": "PDF generation failed.",
    "editRequestNoteRequired": "Describe what changes you want.",
    "editRequestSent": "The edit request was sent.",
    "editRequestSendFailed": "Failed to send the request.",
    "editRequestApproved": "You approved the edit request.",
    "editRequestRejected": "You rejected the edit request.",
    "actionFailed": "The action failed.",
    "editSavedPendingApproval": "Changes saved — waiting for final approval.",
    "saveFailed": "Failed to save.",
    "editFinalized": "The agreement was updated.",
    "editFinalizeRejected": "The changes were rejected — reverting to previous values.",
    "multiSignSuccess": "You signed the agreement.",
    "signFailed": "Signing failed.",
    "disputeOpened": "The dispute was opened.",
    "disputeOpenFailed": "Failed to open the dispute.",
    "blameAccepted": "You accepted responsibility.",
    "disputeGoesToVote": "The dispute moves to a vote by the remaining parties.",
    "voteRecorded": "Your vote was recorded.",
    "voteFailed": "Voting failed.",
    "sendActionFailed": "Sending failed.",
    "earlyCompletionTitle": "Early completion",
    "earlyCompletionBody": "The agreement expires on {{date}}. Do you want to complete it early?",
    "yesCompleteEarly": "Yes, complete it",
    "completionRejectedContinues": "The completion request was rejected — the agreement continues.",
    "inviteeLabel": "{{email}} (invited)",
    "invitedLabel": "{{name}} (invited)",
    "refundOnMutual": "\n\nYour signature is refunded to your ink balance.",
    "refundIfMutual": "\n\nIf the cancellation is mutual, your signature is refunded to your ink balance.",
    "feeFromInk": "1 signature will be charged from your ink balance.",
    "feeChargeInk": "1 ink will be charged to activate the agreement.",
    "feeFree": "Free — no charge.",
    "acceptTitle": "Sign agreement",
    "acceptMessage": "You accept the terms of the agreement \"{{title}}\" and commit to honoring them.\n\n{{feeNote}}",
    "acceptConfirmLabel": "Sign",
    "rejectTitle": "Reject agreement",
    "rejectMessage": "You are rejecting the agreement proposal \"{{title}}\".\n\n{{name}} will be notified of the rejection. There is no charge.",
    "rejectConfirmLabel": "Reject",
    "withdrawTitle": "Withdraw proposal",
    "withdrawMessage": "You are withdrawing the proposal \"{{title}}\" before {{name}} accepts it.\n\nThe agreement is saved as a draft — you can edit and resend it anytime. There is no charge.",
    "withdrawConfirmLabel": "Withdraw",
    "completeTitle": "Mark as Completed",
    "completeMessage": "You are marking the agreement \"{{title}}\" as completed.\n\nOnce completed, both sides can review the collaboration.",
    "completeConfirmLabel": "Complete",
    "terminateTitle": "Complete agreement",
    "terminateMessage": "You are completing the agreement \"{{title}}\".\n\n{{name}} will be notified. Once completed, both sides can review the collaboration.",
    "terminateConfirmLabel": "Complete",
    "cancelRequestTitle": "Cancellation request",
    "cancelRequestMessage": "You are requesting cancellation of the active agreement \"{{title}}\".\n\n{{name}} will be notified and can agree or refuse. If they refuse, the agreement continues normally.",
    "cancelRequestConfirmLabel": "Request cancellation",
    "cancelAgreeTitle": "Accept cancellation",
    "cancelAgreeMessage": "You agree to cancel the agreement \"{{title}}\" requested by {{name}}.\n\nThe cancellation is mutual — no one loses rating.",
    "cancelAgreeConfirmLabel": "Agree to cancellation",
    "completeAgreementBtn": "Complete agreement",
    "endOngoingAgreementBtn": "End collaboration",
    "cancelAgreementBtn": "Cancel agreement",
    "multiCancelRequestBtn": "Request full cancellation",
    "multiCancelRequestTitle": "Cancel multi-party agreement",
    "multiCancelRequestMessage": "All members will be asked to consent to cancellation. If even one disagrees, the cancellation is aborted and the agreement continues normally. No one loses rating if everyone agrees.",
    "multiCancelRequestConfirm": "Request cancellation",
    "multiCancelRequestSent": "Cancellation request sent to all members.",
    "multiCancelRejectedContinues": "A member disagreed — cancellation was aborted, the agreement continues.",
    "multiCancelVoteRecorded": "Your vote was recorded ({{agreed}}/{{total}} agreed so far).",
    "multiCancelWaitingOthers": "You agreed to cancel — waiting for the others ({{agreed}}/{{total}}).",
    "multiCancelRequestedBy": "{{name}} requested cancellation ({{agreed}}/{{total}} have agreed). Do you agree too?",
    "multiWithdrawBtn": "Withdraw on my own",
    "multiWithdrawTitle": "Unilateral withdrawal",
    "multiWithdrawMessage": "You will leave the agreement — the others continue normally and your share is redistributed to them. This counts as a unilateral cancellation on your own reliability rating. This action cannot be undone.",
    "multiWithdrawConfirm": "Withdraw",
    "multiWithdrawDone": "You withdrew from the agreement.",
    "multiPartyWithdrawnTag": "Withdrew",
    "youWithdrewFromThisAgreement": "You've withdrawn from this agreement. You no longer have access to its contents.",
    "multiCancelAllAgreedDone": "Everyone agreed — the agreement was cancelled by mutual consent.",
    "requestCompletionTitle": "Declare Completion",
    "requestCompletionMessage": "You are declaring that you completed the agreement \"{{title}}\".\n\n{{name}} will be notified and must confirm or refuse. If they refuse, the declaration is cancelled and you can redeclare or open a dispute.",
    "requestCompletionConfirmLabel": "Declare completion",
    "confirmCompletionTitle": "Confirm Completion",
    "confirmCompletionMessage": "{{name}} declares that they completed the agreement \"{{title}}\".\n\nIf you confirm, the agreement closes permanently and both of you can review the collaboration.",
    "confirmCompletionConfirmLabel": "Confirm completion",
    "rejectCompletionTitle": "Reject Completion",
    "rejectCompletionMessage": "You are rejecting {{name}}'s completion declaration for the agreement \"{{title}}\".\n\nThe declaration is cancelled. {{name}} will be notified and can redeclare or open a dispute.",
    "declarePaymentTitle": "Declare Payment",
    "declarePaymentMessage": "You are declaring that you paid for the agreement \"{{title}}\".\n\n{{name}} will be notified and must confirm receipt or refuse. If they refuse, the declaration is cancelled.",
    "declarePaymentConfirmLabel": "Declare payment",
    "confirmPaymentTitle": "Confirm Payment",
    "confirmPaymentMessage": "{{name}} declares that they paid for the agreement \"{{title}}\".\n\nIf you confirm, the payment is recorded on the agreement. Make sure you received the payment before confirming.",
    "confirmPaymentWarning": "This confirmation is final. If you have not received payment, tap \"Decline\".",
    "confirmPaymentConfirmLabel": "Confirm receipt",
    "rejectPaymentTitle": "Reject Payment",
    "rejectPaymentMessage": "You are rejecting {{name}}'s payment declaration for the agreement \"{{title}}\".\n\nThe declaration is cancelled. {{name}} will be notified. If the disagreement continues, you can open a dispute.",
    "rejectPaymentConfirmLabel": "I haven't received payment",
    "rejectCancelTitle": "Reject cancellation request",
    "rejectCancelMessage": "You are rejecting {{name}}'s cancellation request.\n\n{{name}} will be notified. The agreement continues normally with no consequences.",
    "rejectCancelConfirmLabel": "Reject request",
    "declineVerb": "Decline",
    "messagesTitle": "Messages",
    "messagesParticipantsPrefix": "Participants:",
    "messagesReadBy": "read by {{names}}",
    "messagesEmpty": "Send a message to the other party inside the app.",
    "messagesUnreadDivider": "UNREAD",
    "messagesPlaceholder": "Type a message…",
    "messagesGdprNotice": "Messages here are stored and may be used as evidence if a dispute is opened on this agreement. It's recommended to discuss anything related to the agreement inside this chat, so you have evidence if you ever need to dispute it.",
    "messagesGdprAck": "Got it",
    "messagesFromBusiness": "from {{name}}",
    "messagesLoadError": "Couldn't load messages.",
    "messagesSendError": "Message wasn't sent. Try again.",
    "circleChatEmpty": "Send a message to {{name}} through the app.",
    "circleChatPlaceholder": "Write a message…",
    "circleChatBlockConfirmBody": "You won't be able to send each other messages anymore. You can undo this later.",
    "circleChatBlockedByMeNotice": "You've blocked {{name}}. You can't send each other messages.",
    "circleChatBlockedMeNotice": "{{name}} has blocked you — you can't send a message.",
    "messagesClosedAgreement": "This agreement is closed — you can no longer send messages.",
    "messagesNeedsSignature": "You need to sign the agreement first to join the conversation.",
    "messagesDisputeLocked": "This conversation is locked while a dispute is pending — jurors can view it anonymously as evidence.",
    "messagesYou": "You",
    "messagesSearchLabel": "Search messages",
    "messagesSearchPlaceholder": "Search for a word…",
    "messagesTypingOne": "{{name}} is typing…",
    "messagesTypingMany": "{{names}} are typing…",
    "replyAction": "Reply",
    "reportMessageAction": "Report message",
    "messageOptionsAction": "Message options",
    "blockUserAction": "Block {{name}}",
    "reportModalTitle": "Why are you reporting this message?",
    "reportReason_spam": "Spam",
    "reportReason_offensive": "Offensive content",
    "reportReason_scam": "Scam",
    "reportReason_harassment": "Harassment",
    "reportReason_other": "Other",
    "reportNotePlaceholder": "Optional note…",
    "reportSubmit": "Send report",
    "reportSentTitle": "Report sent",
    "reportSentBody": "Thank you — our team will review it.",
    "reportError": "Couldn't send the report. Try again.",
    "blockConfirmTitle": "Block {{name}}?",
    "blockConfirmBody": "You won't be able to message each other in any shared agreement anymore. You can undo this later.",
    "blockAction": "Block",
    "blockError": "Something went wrong. Try again.",
    "unblockAction": "Unblock",
    "blockedByMeNotice": "You've blocked {{name}}. You can't message each other.",
    "blockedMeNotice": "{{name}} has blocked you — you can't send messages in this agreement.",
    "labelType": "Type",
    "typeFixedTerm": "Fixed term",
    "typeOngoing": "Open-ended",
    "typeOneOff": "One-off",
    "labelDuration": "Duration",
    "notSet": "Not set",
    "labelDate": "Date",
    "partiesCount": "Parties ({{count}})",
    "creatorTag": "(creator)",
    "multiSignedWaitingOthers": "You signed ✓ — waiting for the others to sign.",
    "acceptBlame": "Accept responsibility",
    "disagree": "Disagree",
    "waitingAccusedResponse": "Waiting for the accused's response…",
    "othersVoting": "The remaining parties are voting on who is right…",
    "juryReviewWaiting": "The dispute has moved to drawn jurors — you'll be notified once they decide.",
    "juryReviewBystander": "Jurors have been drawn for this dispute (you may be one of them — check \"Jury Duties\").",
    "voteWhoIsRight": "Vote on who is right",
    "initiatorSays": "{{name}} says:",
    "initiatorFallback": "Initiator",
    "accusedReplies": "{{name}} replies:",
    "accusedFallback": "Accused",
    "neutralVote": "Neutral / Don't know",
    "voteAlreadyCast": "You voted: {{name}}. Your vote was recorded — waiting for the rest to vote.",
    "noMajorityAdminReview": "No clear majority emerged — the dispute is awaiting an admin review.",
    "outcomeEvidenceBased": "The dispute was resolved based on objective payment evidence. The agreement was cancelled.",
    "outcomeVoteMajority": "The vote of the remaining parties reached a decision. The agreement was cancelled.",
    "outcomePenaltyRespondent": "The accused accepted responsibility. The agreement was cancelled.",
    "outcomeDefault": "The dispute was concluded. The agreement was cancelled.",
    "multiCommitmentIntro": "The parties ({{names}}) mutually commit to abide by the following:",
    "creatorSavedChangesApprove": "The creator saved changes to the agreement — do you approve them?",
    "approve": "Approve",
    "waitingFinalApproval": "Waiting for final approval of the changes from {{name}}…",
    "editRequestPendingApproval": "Edit request awaiting approval from {{name}}…",
    "editRequestTitle": "Edit Request: \"{{note}}\"",
    "approvalNoun": "Approval",
    "editAgreementTitle": "Edit Agreement",
    "editApprovedWaitingChanges": "The request was approved — waiting for changes from {{name}}…",
    "editRequestLinkLabel": "Request agreement edit",
    "termsAndConditionsOf": "Terms & Conditions of {{name}}",
    "signedByAllParties": "✓ Digitally signed by all parties",
    "completionRequestSent48h": "⏳ Completion request sent to {{name}}. If they don't respond within 48 hours, the agreement completes automatically.",
    "freeSendNotice": "Sending is free. The 1 ink charge only applies if you both agree — then you're each charged 1 ink. If it doesn't close, no one is charged.",
    "signedFreeWaitingActivation": "You signed for free ✓ — waiting for {{name}} to sign to activate it.",
    "inviteSentAutoLink": "An invite was sent to {{email}}. They will be linked to the agreement automatically once they register with that email.",
    "sendingCompletionRequestIn": "Sending completion request in {{count}}…",
    "paymentDeclaredConfirmQuestion": "{{name}} declares payment — is that true?",
    "confirmVerb": "Confirm",
    "waitingPaymentConfirmation": "Waiting for payment confirmation from {{name}}…",
    "completionRequestConfirmQuestion": "{{name}} requests completion of the agreement — do you agree?",
    "cancelRequestConfirmQuestion": "{{name}} requests cancellation — do you agree?",
    "doNotWantCancel": "I don't want to cancel",
    "respondToDispute": "Respond to Dispute",
    "manageDispute": "Manage Dispute",
    "awaitingMutualResolutionResponse": "You're waiting for a response for a mutual resolution. {{name}} has until {{date}} to respond.",
    "respondToResolutionProposal": "Respond to Resolution Proposal",
    "agreementIsStatus": "The agreement is \"{{status}}\".",
    "disputeEndedLeaveReview": "The dispute with {{name}} ended — leave your review",
    "collaborationEndedLeaveReview": "The collaboration with {{name}} ended — leave your review",
    "reviewName": "Review {{name}}",
    "allPartiesReviewed": "You reviewed all the parties ✓",
    "disputeEndedLeaveReviews": "The dispute ended — leave your reviews ({{count}} remaining)",
    "collaborationEndedLeaveReviews": "The collaboration ended — leave your reviews ({{count}} remaining)",
    "editRequestModalTitle": "Edit Request",
    "editRequestModalSubtitle": "Describe what changes you want to the agreement.",
    "editRequestPlaceholder": "e.g. Change amount to €250 and new expiry date",
    "whoIsDisputeAbout": "Who is the dispute about?",
    "openDispute": "Open Dispute",
    "termsDescriptionLabel": "Terms / Description",
    "labelAmountPlain": "Amount"
  },
  "offers": {
    "tab_label": "Offers",
    "type_label": "Offer type",
    "type_one_off": "With deadline",
    "type_one_off_sub": "One job",
    "type_ongoing": "Ongoing",
    "type_ongoing_sub": "Open-ended collaboration",
    "type_fixed_term": "From-To",
    "type_fixed_term_sub": "Fixed period",
    "title": "Offers",
    "new": "New Offer",
    "received": "Received",
    "sent": "Sent",
    "accept": "Accept",
    "decline": "Decline",
    "withdraw": "Withdraw",
    "status": {
      "pending": "Pending",
      "accepted": "Accepted",
      "declined": "Declined",
      "withdrawn": "Withdrawn",
      "expired": "Expired",
      "draft": "Draft"
    },
    "fields": {
      "title": "Title",
      "description": "Description",
      "amount": "Amount (€)",
      "expires_at": "Expires"
    },
    "empty_received": "You have no received offers.",
    "empty_sent": "You have no sent offers.",
    "error_load": "Could not load offer.",
    "confirm_decline": "Are you sure you want to decline this offer?",
    "confirm_withdraw": "Are you sure you want to withdraw this offer?",
    "notFound": "Offer not found.",
    "noDescription": "No description",
    "expired": "Expired",
    "declined": "Declined",
    "closedByOther": "Closed — went to another",
    "from": "From",
    "expiresIn_one": "Expires in 1 day",
    "expiresIn_other": "Expires in {{count}} days",
    "deliveryDays": "{{count}}-day delivery",
    "acceptanceInfo": "Accepting will automatically create a Heirapsia agreement.",
    "waitingForAcceptance": "Waiting for the other party to accept…",
    "acceptedSuccess": "Offer accepted! The agreement has been created.",
    "acceptedWaiting": "You accepted. Waiting for the creator to sign.",
    "inkInfo": "The client signs for free; you sign last with 1 ink.",
    "created_title": "Offer created!",
    "created_body": "Share the link below so the other party can accept it.",
    "shareFromLine": "Offer from {{name}}",
    "share_invite_code": "\nAccess code: {{code}}",
    "emailSent": "Email sent to recipient.",
    "field_title": "Job title",
    "field_recipient": "Recipient (optional)",
    "field_cost": "Cost (€)",
    "field_deliveryTime": "Delivery time",
    "field_descriptionOptional": "Service description (optional)",
    "field_description": "Service description",
    "section_description": "Description",
    "section_terms": "Terms & Conditions",
    "section_declineReason": "Decline reason",
    "field_cost_label": "Cost",
    "field_delivery_label": "Delivery",
    "days_suffix": "days",
    "review_title": "Offer summary",
    "review_titleLabel": "Title",
    "review_recipientLabel": "Recipient",
    "review_costLabel": "Cost",
    "review_deliveryLabel": "Delivery",
    "review_descriptionLabel": "Description",
    "action_accept": "Accept Offer",
    "action_withdrawDraft": "Withdraw to draft",
    "action_reuseAsDraft": "Reuse as draft",
    "action_shareLink": "Copy / Share link",
    "action_resendEmail": "Resend email",
    "action_viewAgreement": "View agreement",
    "action_send": "Send Offer",
    "confirmAccept_title": "Accept Offer",
    "confirmAccept_message": "A Heirapsia agreement will be automatically created.",
    "confirmAccept_label": "I Accept",
    "decline_title": "Decline Offer",
    "decline_subtitle": "Please briefly explain why you are declining.",
    "shareLink_label": "Send the offer link",
    "copy_chip": "Copy",
    "other_chip": "Other",
    "withdraw_title": "Withdraw offer",
    "withdraw_message": "Are you sure you want to withdraw this offer?",
    "withdraw_confirm": "Withdraw",
    "link_copied_title": "Copied",
    "link_copied_body": "The offer link was copied to clipboard.",
    "resent_title": "Sent",
    "resent_body": "The email was resent to {{email}}.",
    "incoming_title": "Incoming Offers",
    "incoming_empty_title": "No incoming offers",
    "incoming_empty_body": "Offers sent to you by other users will appear here.",
    "sent_title_screen": "My Offers",
    "sent_empty_title": "No offers sent yet",
    "sent_empty_body": "Create a new offer to get started.",
    "filter_all": "All",
    "filter_empty": "No offers match this filter."
  },
  "offersScreens": {
    "currencyLabel": "Currency",
    "errorRecipientNameRequired": "The recipient's full name is required.",
    "recipientNameLabel": "Recipient's full name",
    "recipientNamePlaceholder": "e.g. John Smith",
    "offerAddressedTo": "Offer addressed to: {{name}}",
    "printOrSendOffer": "Print / send offer",
    "printFailed": "Printing the offer failed.",
    "printAgainButton": "Print / Save offer PDF",
    "coach1_title": "Job title",
    "coach1_text": "Short, descriptive name for your job. E.g. \"Website build\". The client sees this as the offer's headline.",
    "coach2_title": "Service description",
    "coach2_text": "Exactly what you provide, what's included and what's excluded. The more detailed the description, the fewer misunderstandings with the client.",
    "coach3_title": "Cost (€)",
    "coach3_text": "The total amount for the job in euros. You can leave it blank if you haven't settled on a price yet.",
    "coach4_title": "Delivery time",
    "coach4_text": "How many days you'll deliver the work after the collaboration starts. The client will see this info before signing.",
    "coach5_title": "Send to client",
    "coach5_text": "Search by name if the client is already on Heirapsia (they'll get a notification), or enter an email for an external client (they'll get a link).",
    "coachSkip": "Skip",
    "coachNext": "Next →",
    "coachStart": "Let's go ✓",
    "saveTemplateFailed": "Saving the template failed.",
    "replaceTemplateFailed": "Replacement failed.",
    "saveAsTemplateTitle": "Save as template?",
    "saveAsTemplateMessage": "Would you like to also save this offer as a template, so you can reuse it by just changing the recipient?",
    "createOfferFailed": "Failed to create offer.",
    "duplicateBusinessOffer": "Your business partner {{name}} already sent an offer to this customer/request — avoid sending a duplicate offer from the same business.",
    "successBody": "Send the link to the client. Once they sign, you'll get a notification to sign too.",
    "successBodyRegistered": "Sent to {{name}} — they'll be notified in the app. If you want, you can also share the link or print it to hand over in person.",
    "emailSentTo": "Offer email sent to {{email}}",
    "templateNameTitle": "Template name",
    "templateNameLabel": "Name",
    "templateNamePlaceholder": "e.g. Basic website offer",
    "hasThreeTemplatesTitle": "You already have 3 templates",
    "chooseTemplateToReplace": "Choose which one to replace:",
    "newOfferTitle": "New offer",
    "entryChoiceSubtitle": "Would you like to start from scratch or use a saved template?",
    "entryNewTitle": "New offer",
    "entryNewSub": "Start from a blank form.",
    "entryTemplateTitle": "Use a template",
    "entryTemplateSub_one": "{{count}} saved — just change the recipient.",
    "entryTemplateSub_other": "{{count}} saved — just change the recipient.",
    "manageTemplates": "Manage templates",
    "chooseTemplateTitle": "Choose a template",
    "titlePlaceholder": "e.g. Website build",
    "recipientPlaceholder": "Client name or email…",
    "recipientHintUser": "Heirapsia user — they'll get a notification.",
    "recipientHintSearch": "Search by name or enter an email. You can skip this.",
    "offerKindLabel": "Offer type",
    "offerKindService": "Service",
    "offerKindGoods": "Goods",
    "sendAsLabel": "Send as",
    "sendAsMe": "Me",
    "sendAsBusiness": "The business",
    "costPlaceholder": "e.g. 500",
    "vatLabel": "VAT",
    "vatWithout": "Without VAT",
    "vatWith": "With VAT",
    "vatRateLabel": "VAT %",
    "vatRatePlaceholder": "e.g. 24",
    "priceWithoutVat": "Price (without VAT)",
    "finalPriceWithVat": "Final price (with VAT)",
    "vatAmountLabel": "VAT ({{rate}}%)",
    "totalWithoutVat": "Total (without VAT)",
    "finalTotalWithVat": "Final total (with VAT)",
    "subtotalLabel": "Subtotal",
    "discountLabel": "-Discount",
    "deliveryDaysPlaceholder": "e.g. 7",
    "daysSuffix": "days",
    "startDateLabel": "Start date",
    "endDateLabel": "End date",
    "durationHint": "Duration: {{days}} days.",
    "serviceDescriptionPlaceholder": "Detailed description of what you provide…",
    "goodsDescriptionPlaceholder": "Additional notes for the order…",
    "productTitle": "Product {{index}}",
    "productDescriptionLabel": "Product description",
    "productDescriptionPlaceholder": "e.g. Backpack model X",
    "productQuantityLabel": "Quantity",
    "productUnitPriceLabel": "Unit price €",
    "productDiscountLabel": "Discount",
    "addProduct": "New product",
    "reviewTypeLabel": "Type",
    "reviewPeriodLabel": "Period",
    "finalPriceWithVatTag": "{{cost}} € (with VAT)",
    "finalPriceLabel": "Final price",
    "errorTitleRequired": "Give the offer a title.",
    "errorProductsRequired": "Fill in description, quantity (>0) and price for each product.",
    "errorDescriptionRequired": "Fill in a description.",
    "errorInvalidAmount": "Invalid amount.",
    "errorInvalidDays": "Invalid number of days.",
    "errorStartDateRequired": "Select a start date.",
    "errorEndDateRequired": "Select an end date.",
    "errorEndAfterStart": "The end date must be after the start date.",
    "errorInvalidEmail": "Invalid email.",
    "errorLoadFailed": "Failed to load.",
    "errorAcceptFailed": "Failed to accept.",
    "errorDeclineFailed": "Failed to decline.",
    "shareCodeLine": "\nAccess code: {{code}}",
    "shareOfferText": "I sent you a professional offer \"{{title}}\" via Heirapsia:",
    "errorResendFailed": "Failed to send.",
    "resentTitle": "Sent",
    "resentBody": "The email was resent to {{email}}.",
    "errorResendEmailFailed": "Failed to send email.",
    "errorWithdrawFailed": "Failed to withdraw.",
    "errorCloneFailed": "Failed to clone.",
    "goodsSectionTitle": "Goods",
    "finalTotalLabel": "Final total",
    "resendEmailButton": "Resend email to {{email}}",
    "declineReasonPlaceholder": "e.g. The cost doesn't fit my budget",
    "loadFailed": "Loading failed.",
    "renameFailed": "Rename failed.",
    "deleteFailed": "Delete failed.",
    "deleteTemplateTitle": "Delete template",
    "deleteTemplateMessage": "Are you sure you want to delete \"{{name}}\"?",
    "templatesTitle": "Offer templates",
    "noTemplatesTitle": "You have no saved templates",
    "noTemplatesBody": "When you create an offer, you can save it as a template to reuse it.",
    "templatesCountHint": "{{count}}/{{max}} templates",
    "productCount_one": "{{count}} product — {{total}}€",
    "productCount_other": "{{count}} products — {{total}}€",
    "noSetCost": "No set cost",
    "useAction": "Use",
    "renameAction": "Rename",
    "deleteAction": "Delete",
    "renameTemplateTitle": "Rename template",
    "templateNameFieldPlaceholder": "Template name"
  },
  "contactsMatch": {
    "title": "Contacts on Heirapsia",
    "homeBannerFind": "My contacts on Heirapsia",
    "homeBannerCount_one": "{{count}} contact of yours is already on Heirapsia",
    "homeBannerCount_other": "{{count}} contacts of yours are already on Heirapsia",
    "homeChipFind": "Contacts",
    "homeChipCount_one": "{{count}} contact",
    "homeChipCount_other": "{{count}} contacts",
    "outsideCircleBanner_one": "{{count}} of your contacts is outside your circle!",
    "outsideCircleBanner_other": "{{count}} of your contacts are outside your circle!",
    "circleDiscoverBanner": "Which of your contacts are already on Heirapsia? 🔎",
    "explainerTitle": "Access to your contacts",
    "explainerIntro": "To show you which friends are already on Heirapsia, we need access to your device's contacts.",
    "explainerWhat": "What we read: the names and phone numbers of your contacts.",
    "explainerWhy": "Why: to see which of them already have a Heirapsia account, so you can easily add them to your circle.",
    "explainerHow": "How: phone numbers are sent over a secure encrypted connection only for comparison — they are not stored permanently on our servers.",
    "explainerAgree": "Agree",
    "explainerDecline": "No thanks",
    "permissionDenied": "Contacts access was not granted. You can enable it from device settings.",
    "loadError": "Could not load contacts.",
    "empty": "None of your contacts are on Heirapsia yet.",
    "connect": "Connect",
    "connected": "In your circle",
    "pending": "Sent",
    "pendingReceived": "Invited you"
  },
  "circle": {
    "tab_label": "Circle",
    "title": "Circle",
    "my_circle": "My Circle",
    "search_placeholder": "Search user...",
    "no_connections": "You have no connections yet.",
    "request_sent": "Request sent",
    "connected": "Connected",
    "connect": "Connect",
    "pending": "Pending",
    "accept": "Accept",
    "decline": "Decline",
    "remove": "Remove from circle",
    "view_profile": "Profile",
    "new_agreement": "New Agreement",
    "new_offer": "New Offer",
    "me": "Me",
    "connectionCount": "{{count}} conn.",
    "connectionRequests": "Connection requests ({{count}})",
    "newAnnouncement": "New announcement",
    "announcement": "Make an\nannouncement",
    "outsideCircle": "outside circle",
    "userNotFound": "User not found",
    "stats": "{{connections}} contacts · {{mutual}} mutual connections",
    "empty_title": "Your circle is empty",
    "empty_body": "Add connections to see them here.",
    "action_findUsers": "Find users",
    "action_newAgreement": "+ Agreement",
    "action_sendOffer": "Send offer",
    "filter_all": "All",
    "filter_activeAgreement": "Active agreement",
    "filter_professionals": "Professionals",
    "badge_professional": "Professional",
    "filter_recent": "Recent",
    "retry": "Retry",
    "tab_contacts": "Contacts",
    "tab_feed": "Posts",
    "feed_empty": "No professional posts in your circle yet.",
    "pro_notice": "Showing all professionals with a Public profile",
    "facet_services": "Services",
    "facet_eshop": "With eShop",
    "facet_physical_only": "Physical store",
    "map_expand": "Tap to expand the map",
    "map_collapse": "Collapse map",
    "sonar_nearestRegion": "No professionals found in your area — showing the nearest: {{region}}",
    "sonar_noneNearby": "No professionals found nearby.",
    "sonar_seeAll": "See all of Greece",
    "sonar_openMap": "Open the map",
    "sonar_scanning": "Scanning for professionals near you...",
    "intro_title": "Find professionals",
    "intro_map": "Browse professionals on a map by region, or as a list.",
    "intro_facets": "Filter with capsules: Services, eShop, physical store.",
    "intro_sonar": "We automatically show your region — if there are none there, we scan the nearest ones.",
    "intro_requests": "In the \"Job Requests\" tab you can ask for what you need and receive offers.",
    "intro_gotIt": "Got it",
    "pro_empty": "No professionals found matching these criteria.",
    "pro_resultsCount": "{{count}} results found.",
    "pro_completedCount": "{{count}} completed",
    "pro_sponsored": "Promoted",
    "filters": "Filters",
    "filtersRegion": "Region Filters",
    "showResults": "Show results",
    "filter_region": "Region",
    "filter_profession": "Profession",
    "filter_professionAll": "All",
    "filter_apply": "Apply",
    "viewAnnouncement": "View announcement",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "stats_connections_one": "{{count}} contact",
    "stats_connections_other": "{{count}} contacts",
    "stats_mutual_one": " · {{count}} mutual connection between them",
    "stats_mutual_other": " · {{count}} mutual connections between them",
    "time_justNow": "just now",
    "time_minutesAgo": "{{count}}m ago",
    "time_hoursAgo": "{{count}}h ago",
    "time_daysAgo": "{{count}}d ago"
  },
  "profile": {
    "title": "Profile",
    "edit_title": "Edit profile",
    "full_name": "Full name",
    "bio": "Bio",
    "phone": "Phone",
    "specialty": "Specialty",
    "business_name": "Business name",
    "contact_email": "Contact email",
    "signature": "Signature",
    "save": "Save changes",
    "saved": "Changes saved.",
    "avatar_change": "Change photo",
    "adminControls": "Admin controls",
    "logo_change": "Change logo",
    "verified": "Verified",
    "not_verified": "Not verified",
    "level": "Level {{level}}",
    "agreements_count": "{{count}} agreements",
    "reviews": "Reviews",
    "no_reviews": "No reviews yet.",
    "portfolio": "Portfolio",
    "portfolio_empty": "No announcements.",
    "signature_locked_hint": "You need more ink to unlock your signature.",
    "section_professional": "Professional Account",
    "tab_personal": "Personal",
    "tab_professional": "Professional",
    "signatureLocked_title": "Signature locked",
    "signatureLocked_body": "You need more ink to sign agreements.",
    "signature_welcome": "Draw your signature below",
    "portfolio_enable": "Enable portfolio page",
    "portfolio_public": "Public",
    "portfolio_private": "Private",
    "portfolio_showBusiness": "Show business name on profile",
    "portfolio_useLogo": "Use logo as profile photo",
    "field_firstName": "First name",
    "field_lastName": "Last name",
    "field_phone": "Mobile phone",
    "field_specialty": "Specialty (optional)",
    "field_businessName": "Business name (optional)",
    "field_businessLogo": "Business logo (optional)",
    "action_newSignature": "New signature",
    "action_removeSignature": "Remove signature",
    "action_addSignature": "Add signature",
    "action_saveChanges": "Save changes",
    "action_saveShort": "Save",
    "action_addLogo": "Add logo",
    "action_viewPortfolio": "See how your portfolio looks",
    "action_setupAccount": "Set up account",
    "sponsor_title": "Promote profile",
    "sponsor_body": "Rank higher in the professional search list by paying with ink — charged daily, no prepayment.",
    "sponsor_activeRegional": "Active promotion in your region, {{rate}} ink/day.",
    "sponsor_activeNationwide": "Active promotion everywhere, {{rate}} ink/day.",
    "sponsor_actionStart": "Start promotion",
    "sponsor_actionEdit": "Change rate / tier",
    "sponsor_actionUpdate": "Update promotion",
    "sponsor_actionCancel": "Deactivate promotion",
    "sponsor_modalTitle": "Promote profile",
    "sponsor_modalHint": "Promoted professionals appear first in search results, marked as \"Promoted\". Ranking among them is decided by daily rate — whoever pays more shows first.",
    "sponsor_tierRegional": "In my region ({{region}})",
    "sponsor_tierNoRegion": "needs a region",
    "sponsor_tierNationwide": "Everywhere",
    "sponsor_pricePerDayFrom": "from {{amount}} ink/day",
    "sponsor_rateLabel": "Your daily rate",
    "sponsor_ratePlaceholder": "Ink/day",
    "sponsor_perDay": "/day",
    "sponsor_outbid": "Beat the top bidder ({{amount}} ink/day)",
    "sponsor_nightlyNote": "No prepayment — you're charged every night for the next day. If your ink runs out, promotion stops automatically.",
    "sponsor_confirm": "Activate promotion",
    "sponsor_errorMinRate": "Minimum daily rate is {{amount}} ink.",
    "sponsor_errorGeneric": "Promotion failed.",
    "sponsor_whereTitle": "Where you'll show up",
    "sponsor_whereListRegion": "First in search results in {{region}}",
    "sponsor_whereListEverywhere": "First in search results in every region",
    "sponsor_whereBanner": "In the rotating banner of \"Find professionals\", for anyone browsing {{region}}",
    "action_changeLogo": "Change",
    "verifyHint": "Verify your phone to increase your reliability score.",
    "otpSent": "SMS sent. Enter the 6-digit code.",
    "uploading": "Uploading…",
    "tapToChange": "Tap to change",
    "addSignature": "Add signature",
    "wizard_step1_title": "Business details",
    "wizard_step1_subtitle": "Tell us about your business.",
    "wizard_step2_title": "Logo",
    "wizard_step2_subtitle": "Add your business logo.",
    "wizard_step3_title": "Review",
    "wizard_step3_subtitle": "Check before saving.",
    "setupWizard_step1_title": "Identity",
    "setupWizard_step1_subtitle": "Tell us what you do and where you're based.",
    "setupWizard_step2_title": "Logo",
    "setupWizard_step2_subtitle": "Add a business logo (optional).",
    "setupWizard_step3_title": "Contact details",
    "setupWizard_step3_subtitle": "How clients will find you.",
    "setupWizard_step4_title": "Payments & eShop",
    "setupWizard_step4_subtitle": "Payment methods and your online store, if any.",
    "setupWizard_step5_title": "Terms & Partners",
    "setupWizard_step5_subtitle": "Your terms, and whether you work with partners.",
    "setupWizard_step6_title": "Review",
    "setupWizard_partnersQuestion": "Do you work alone or with partners?",
    "setupWizard_worksAlone": "I work alone",
    "setupWizard_hasPartners": "I have partners",
    "setupWizard_alreadyInBusiness": "You're a member of \"{{business}}\".",
    "setupWizard_paymentsHint": "Add the ways you accept payments, and optionally your eShop page, if you have one.",
    "business_needNameFirst": "Fill in the business name first, in the \"Identity\" step.",
    "review_business": "Business",
    "review_specialty": "Specialty",
    "review_visibility": "Visibility",
    "review_logo": "Logo",
    "saving_portfolio": "Saving…",
    "complete_portfolio": "Complete",
    "hint_fullName": "As shown on your ID — it appears in the agreements you sign.",
    "hint_phone": "Not shown publicly. Used for identity verification only.",
    "hint_phone_icon": "Creates a communication icon on your profile to make it easier for people in your circle to reach you.",
    "hint_phone_noVerify": "Works even without phone verification.",
    "info_fullName": "Your full name must match your ID — it appears in agreements you sign and on your full profile. Searches and your Circle will show \"Known as...\" + your last name instead.",
    "info_signature": "Your signature is used to digitally sign agreements.",
    "info_portfolio": "Your portfolio is your public professional page.",
    "info_portfolioPublic": "Your portfolio is visible to everyone.",
    "info_portfolioPrivate": "Your portfolio is only visible to your circle.",
    "alert_signatureSaved": "Your signature was saved.",
    "alert_signatureRemoved": "Your signature was removed.",
    "alert_profileSaved_title": "Saved",
    "alert_profileSaved_body": "Your profile was updated.",
    "verify_banner_title": "Identity Verification",
    "verify_banner_sub": "Without verification your reliability cap is up to 80% — a photo ID raises it up to 100%",
    "section_verifications": "Verifications",
    "verify_identity_title": "Identity Verification",
    "verify_identity_sub": "Your reliability cap is now up to 80% — upload a photo ID to raise it up to 100%",
    "verify_done": "Completed ✓",
    "phone_verified": "Verified mobile",
    "level2_pill": "Lv.2 Identity",
    "comm_title": "Communication Methods",
    "providesBadge": "Provides Services",
    "signaturePadPlaceholder": "Draw your signature here ✍️",
    "tour_signature_title": "Create your signature ✍️",
    "tour_phone_title": "Mobile verification",
    "verify_identity_pending": "Awaiting verification",
    "error_uploadFailed": "Upload failed.",
    "error_logoUploadFailed": "Logo upload failed.",
    "error_saveFailed": "Save failed.",
    "business_sectionTitle": "Business (partners)",
    "business_info": "If your business has 2+ partners, you can share one professional profile — combined rating and completed agreements, instead of each partner adding it separately.",
    "business_create": "Create a business with partners",
    "business_createHint": "You'll become the owner — you can invite partners afterwards.",
    "business_invitePartner": "Invite a partner",
    "business_searchPartnerPlaceholder": "Search by name...",
    "business_inviteByEmail": "Invite {{email}}",
    "business_inviteByEmailHint": "Not found on Heirapsia yet — they'll get an invite email.",
    "business_inviteSent": "Invite sent.",
    "business_inviteReceived": "{{name}} invited you to the business \"{{business}}\".",
    "business_you": "you",
    "business_owner": "Owner",
    "business_showsAsBusinessBadge": "Active in search",
    "identityPicker_title": "Active profession in search",
    "identityPicker_hint": "Choose which identity you want to show up as in the professionals search list.",
    "identityPicker_personal": "Primary profession",
    "businessAddress_public": "Address publicly visible",
    "businessAddress_private": "Private address (only you)",
    "business_ownedTag": "Your business",
    "business_partnerTag": "You're a partner here",
    "business_equityPlaceholder": "Equity % (optional)",
    "business_invitedPending": "Invited",
    "business_leaveAction": "Leave the business",
    "business_leaveConfirmTitle": "Leave the business?",
    "business_leaveConfirmBody": "You'll leave the business \"{{business}}\". You can create or join another business later.",
    "business_removeConfirmTitle": "Remove partner?",
    "business_removeConfirmBody": "{{name}} will be removed from the business.",
    "levelProgress": "{{completed}}/{{required}} → Level {{level}}",
    "sigLockedActive": "You can't change your signature while you have active agreements.",
    "sigLockedUsed": "This signature has been used on an agreement and can't be changed.",
    "sigWelcomeBanner": "✍️ Create your signature to get started!",
    "info_professionalAccount": "Enable a Professional Account if you offer services. You'll get a \"Service Provider\" badge, a public portfolio, and the ability to send Professional Offers to clients.",
    "professionalAccount_active": "Professional Account active",
    "professionalAccount_activate": "Activate Account",
    "portfolio_visibleAll": "(visible to everyone)",
    "portfolio_visibleCircle": "(visible only to my Circle)",
    "field_region": "Region of activity",
    "info_region": "The region where you operate professionally. Used in the location filter of the Professionals tab.",
    "region_select": "Select region",
    "info_specialty": "A short description of the service you offer. Shown as a chip on your portfolio.",
    "info_businessName": "Shown below your name on your public profile.",
    "placeholder_businessName": "e.g. George Technical Services",
    "info_businessLogo": "Shown on your portfolio below your specialty.",
    "field_professionalTerms": "Terms & Conditions",
    "info_professionalTerms": "Your own terms appear on a separate cover page (with your logo) in your agreements' PDF. Start a line with \"- \" for a bullet, or \"1. \" for numbering.",
    "placeholder_professionalTerms": "e.g.\n- 30% deposit before work begins\n- Cancellations within 48 hours are fully refunded\n1. Delivery within the agreed days\n2. Any delay will be communicated promptly",
    "hint_professionalTerms": "A line starting with \"- \" = bullet · \"1. \" = numbering. The text is always shown as plain, safe text — code/HTML is not accepted.",
    "field_eshopUrl": "eShop link",
    "info_eshopUrl": "If you have an online store, add the link here — it'll show as a button on your public profile.",
    "placeholder_eshopUrl": "https://...",
    "hint_eshopUrl": "Optional. For retail businesses with an online store.",
    "field_businessAddress": "Business address",
    "info_businessDetails": "Optional business details — shown on offer and offer-based agreement PDFs.",
    "placeholder_businessAddress": "e.g. 25 Main St",
    "field_businessCity": "City",
    "placeholder_businessCity": "e.g. Athens",
    "field_businessPostalCode": "Postal code",
    "placeholder_businessPostalCode": "e.g. 10563",
    "field_businessPhone": "Landline phone",
    "placeholder_businessPhone": "e.g. 2101234567",
    "field_businessEmail": "Business email",
    "placeholder_businessEmail": "e.g. info@business.com",
    "field_businessVatNumber": "VAT number",
    "placeholder_businessVatNumber": "e.g. 123456789",
    "section_paymentMethods": "Payment methods",
    "info_paymentMethods": "Shown on your public profile so clients know how to pay you. Purely informational — Heirapsia doesn't process any payment, the transaction happens directly outside the app.",
    "hint_paymentMethods": "Optional. Fill in whichever you want to show.",
    "field_paymentAccountHolderName": "Account holder display name",
    "placeholder_paymentAccountHolderName": "The name as it appears on the bank account",
    "placeholder_bankName": "Bank",
    "placeholder_paymentIban": "IBAN",
    "action_addBank": "Add another bank",
    "placeholder_paymentIris": "IRIS (phone number or alias)",
    "placeholder_paymentRevolut": "Revolut payment link",
    "placeholder_paymentViva": "Viva Wallet payment link",
    "region_search_placeholder": "City, region, or postal code…",
    "region_none": "— None —",
    "region_notFound": "No region found.",
    "regionSectionTitle": "Region/Postal code",
    "regionNotSet": "Not set — tap to choose your region",
    "nameLockHint": "🔒 Your name was confirmed by identity verification and can't be changed. Contact support if there's a mistake.",
    "nameAccentHint": "⚠️ Check if your name is missing a Greek accent mark (e.g. Γεώργιος, not Γεωργιος).",
    "nameLockHintActiveAgreement": "🔒 Your name can't be changed while you have an active agreement. It'll unlock once they're all completed/cancelled.",
    "nicknameCheckboxLabel": "People know me by a different name",
    "nicknameCheckboxSublabel": "e.g. Alex instead of Alexander",
    "field_nickname": "Known as... (optional)",
    "placeholder_nickname": "e.g. Alex, John, Maria…",
    "hint_nickname": "This is the name others will see in searches, your Circle, and lists — for easier recognition.",
    "nicknamePreview": "Will show on your profile as: \"Also known as: {{nickname}}\"",
    "nicknameLockHint": "You changed this recently — you can change it again in {{count}} days.",
    "nicknameWillLockWarning": "⚠️ Once saved, this will lock — you'll be able to change it again after 30 days.",
    "field_location": "Location (optional)",
    "field_professionCategory": "Field of work (optional)",
    "field_secondaryCategories": "Secondary categories",
    "info_secondaryCategories": "Pick other categories you also work in, besides your main field. You'll be notified about relevant requests in these categories. Max 5.",
    "field_addSecondaryCategory": "Add category",
    "comm_call": "Regular call",
    "validation_required": "Please fill in your {{label}}.",
    "validation_tooLong": "{{label}} can't exceed 40 characters.",
    "validation_lettersOnly": "Use only letters and hyphens.",
    "validation_tooShort": "{{label}} must be at least 2 characters.",
    "label_firstName": "first name",
    "label_lastName": "last name",
    "error_genericRetry": "Something went wrong. Try again.",
    "comm_infoTitle": "Communication Methods",
    "comm_infoBody": "Choose how users can contact you through active agreements. Only visible to people you have an active agreement with.",
    "comm_needPhone": "Add a mobile number to enable these.",
    "field_bio": "A few words about you (optional)",
    "placeholder_bio": "Short description",
    "field_specialtyFull": "Specialty / What I offer (optional)",
    "placeholder_specialtyFull": "e.g. Electrician, Web Developer, Photographer…"
  },
  "settings": {
    "title": "Settings",
    "account": "Account",
    "edit_profile": "Edit profile",
    "identity_verify": "Identity verification 🎖️",
    "payments": "Payments & receipts",
    "my_pen": "My signature pen",
    "jury_duty": "Jury Duty",
    "preferences": "Preferences",
    "appearance": "Appearance",
    "theme_light": "Light",
    "theme_dark": "Dark",
    "theme_auto": "Automatic",
    "sounds": "Sound effects",
    "language": "Language",
    "my_user_id": "My UserID",
    "user_id_hint": "Share this with the other party for easy lookup in search.",
    "upload_error_default": "Could not upload the file.",
    "attach_uploading": "Uploading…",
    "attach_attached": "Screenshot attached",
    "attach_screenshot": "Attach screenshot (optional)",
    "feedback": "Feedback",
    "suggest_feature": "Suggest a feature",
    "feature_modal_title": "Suggest a feature",
    "feature_modal_subtitle": "What would you like us to improve or add to Heirapsia?",
    "feature_placeholder": "What would you like us to add to Heirapsia?",
    "feature_too_short": "Empty message",
    "feature_too_short_msg": "Please write a message.",
    "feature_error": "Error",
    "feature_error_msg": "Could not send. Please try again.",
    "feature_done_title": "Thank you!",
    "feature_done_body": "Your suggestion has been recorded. We'll review it soon.",
    "legal": "Legal & data",
    "my_data": "My data",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy",
    "how_it_works": "How it works",
    "usage_guide": "User guide",
    "sign_out": "Sign out",
    "admin": "Admin",
    "admin_verifications": "User verifications",
    "rate_app": "Rate ★"
  },
  "payment": {
    "status": {
      "pending": "Pending",
      "paid": "Paid",
      "failed": "Failed",
      "refunded": "Refunded"
    }
  },
  "wallet": {
    "topUp": "Top up ink",
    "kind": {
      "credit_cancellation": "Signature refund",
      "debit_agreement": "Signature charge",
      "refund": "Refund",
      "credit": "Credit",
      "debit": "Debit",
      "topup": "Ink top-up"
    },
    "title": "Pen & Ink",
    "tab_label": "Pen",
    "ink_balance": "Ink balance",
    "ink_unit": "signatures",
    "buy_ink": "Buy ink",
    "topup_title": "Refill your pen",
    "free_remaining": "{{count}} free signatures",
    "history": "History",
    "no_history": "No transactions.",
    "transaction": {
      "debit_agreement": "Agreement signature",
      "credit": "Credit",
      "topup": "Ink purchase",
      "refund": "Refund",
      "credit_cancellation": "Credit cancellation"
    },
    "balance_label": "Available signatures (ink)",
    "balance_hint": "Each agreement uses one signature from your ink balance.",
    "balance_after": "Balance: {{amount}}",
    "freeAgreements": "Free agreements",
    "transactions": "Transactions",
    "empty_title": "No transactions yet",
    "empty_body": "Your ink usage history will appear here.",
    "action_topup": "Refill ink",
    "topup_screen_title": "Refill Ink",
    "topup_subtitle": "Choose an ink package",
    "topup_loadingPrices": "Loading prices…",
    "topup_unit": "ink",
    "topup_info": "Purchases are processed securely via Apple/Google.",
    "topup_buyButton": "Buy {{count}} ink",
    "topup_webOnly": "Ink purchases are available in the mobile app.",
    "topup_purchase_title": "Purchase successful!",
    "topup_purchase_body": "{{count}} ink added to your pen.",
    "purchase_failed": "Purchase failed. Please try again.",
    "web_title": "Buy Ink",
    "web_subtitle": "Ink purchases are only available from the Android app via Google Play.",
    "topup_subtitle_detail": "Choose an ink package. Each ink equals one agreement signature!",
    "topup_infoText": "The purchase is made via Google Play. Ink is credited automatically after confirmation. Not redeemable for cash."
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications.",
    "mark_read": "Read",
    "agreement_new": "New agreement invitation",
    "agreement_signed": "Agreement signed",
    "agreement_completed": "Agreement completed",
    "agreement_cancelled": "Agreement cancelled",
    "agreement_disputed": "Agreement disputed",
    "offer_received": "New offer",
    "offer_accepted": "Offer accepted",
    "offer_declined": "Offer declined",
    "review_received": "New review",
    "level_up": "Level up!",
    "identity_verified": "Identity verified",
    "connection_request": "Connection request",
    "agreement_expiry": "Agreement expiring soon"
  },
  "identity": {
    "title": "Identity verification",
    "subtitle": "Verify your identity to earn the 🎖️ badge",
    "step_front": "Front of ID photo",
    "step_back": "Back of ID photo",
    "step_selfie": "Selfie",
    "submit": "Submit",
    "pending": "Under review",
    "approved": "Verified ✓",
    "rejected": "Rejected",
    "already_verified": "Your identity is already verified."
  },
  "identityVerify": {
    "title": "Identity verification",
    "consent_title": "What will be used",
    "consent_1": "Front photo of your ID",
    "consent_2": "Back photo of your ID",
    "consent_3": "A selfie for comparison",
    "step": "Step {{step}}/3 — {{title}}",
    "action_start": "I agree — Start",
    "action_takePhoto": "Take photo",
    "status_verified": "Your identity is verified 🎖️",
    "status_pending": "Your application is under review",
    "status_rejected": "Your application was rejected",
    "resubmit": "You can submit a new application.",
    "uploading": "Submitting photos…",
    "uploadingHint": "Please wait, don't close the app.",
    "done_title": "Application submitted!",
    "done_body": "We'll review it and notify you of the result.",
    "step1_title": "Front of ID",
    "step1_hint": "Place the front of your ID card clearly in frame.",
    "step2_title": "Back of ID",
    "step2_hint": "Place the back of your ID card clearly in frame.",
    "step3_title": "Selfie",
    "step3_hint": "Take a selfie with good lighting, looking at the camera.",
    "step4_title": "Utility Bill (Optional)",
    "step4_hint": "Take a photo of a phone or electricity bill showing your name and address. This increases your trustworthiness.",
    "action_skipBill": "Skip",
    "consentBullet_photos": "You'll take 3-4 photos: front of ID, back of ID, a selfie, and optionally a utility bill (phone/electricity).",
    "consentBullet_usage": "The photos are used ONLY for manual identity verification by the Heirapsia team.",
    "consentBullet_deletion": "They are deleted immediately after review, whether the application is approved or rejected.",
    "consentBullet_noSharing": "They are not stored permanently and are not shared with third parties.",
    "captureError_default": "Could not capture the photo.",
    "submitError_default": "Submission failed. Please try again."
  },
  "review": {
    "recordedTitle": "Your review has been recorded.",
    "addToCircleTitle": "Add them to your circle",
    "addToCircleBody": "Add {{name}} to your circle to find them more easily!",
    "addToCircleAction": "Add",
    "recordedNoChange": "Your review has been recorded. It's the same as your previous one — nothing changed in the score.",
    "title": "Review",
    "stars_label": "Rating",
    "comment_label": "Comment (optional)",
    "submit": "Submit review",
    "success": "Your review has been submitted.",
    "already_reviewed": "You have already reviewed this agreement.",
    "myReview": "Your review",
    "noTagsForRating": "No tags available for this rating.",
    "permanentWarning": "Reviews are permanent and cannot be edited.",
    "summary_title": "Review summary",
    "summary_rating": "Rating",
    "summary_tags": "Tags",
    "starLabel_1": "Poor",
    "starLabel_2": "Fair",
    "starLabel_3": "Neutral",
    "starLabel_4": "Good",
    "starLabel_5": "Excellent",
    "wizard_step1_title": "Rating",
    "wizard_step1_subtitle": "How did this agreement go?",
    "wizard_step2_title": "Tags",
    "wizard_step2_subtitle": "Select tags that best describe your experience.",
    "wizard_step3_title": "Confirmation",
    "wizard_step3_subtitle": "Review your submission before sending.",
    "confirm_title": "Submit review",
    "confirm_message": "Your review is permanent and cannot be edited.",
    "confirm_label": "Submit",
    "action_submit": "Submit review",
    "action_review": "Review {{name}}",
    "error_rating": "Please select a rating from 1 to 5 stars.",
    "error_tagsRequired": "Please select at least one tag.",
    "errorSubmitFailed": "Submission failed.",
    "wizard_step1_subtitle_named": "How was working with {{name}}?",
    "nowReviewing": "Reviewing: {{name}}",
    "defaultCounterparty": "the other party",
    "defaultCounterpartyGen": "the other party",
    "publicPermanentNotice": "Your review will be public and permanent on {{name}}'s profile.",
    "action_submitAndNext": "Submit & next",
    "photoLabel": "Photo (optional)",
    "photoAddFromGallery": "From gallery",
    "photoTakePhoto": "Take a photo",
    "confirmNoPhoto_title": "Post review without a photo?",
    "confirmNoPhoto_body": "Reviews with a photo help the professional more and also show up in their portfolio.",
    "confirmNoPhoto_confirm": "Continue without a photo",
    "confirmNoPhoto_cancel": "Add a photo"
  },
  "dispute": {
    "banner_juryReviewTitle": "The case has moved to a randomly drawn jury.",
    "banner_juryReviewBody": "3-5 independent users were randomly drawn to judge it impartially — they only see each side's stated reasons, never your name or identity. {{votes}}/{{total}} have already voted.",
    "banner_stakeLocked": "You were charged {{amount}} ink as the filing fee for the jury's review.",
    "banner_adminReview": "The case was escalated to manual admin review.",
    "banner_juryWon": "The jury ruled in your favor. The filing fee ({{amount}} ink) is not refunded — it was the charge for the jury's review, not a refundable stake.",
    "banner_juryLost": "The jury ruled against you — the filing fee ({{amount}} ink) is not refunded.",
    "banner_juryWon_accused": "The jury ruled in your favor — you didn't lose any ink, you never paid a filing fee in this dispute.",
    "banner_juryLost_accused": "The jury ruled against you — you lose rating, but you didn't lose any ink (only the complainant paid the filing fee).",
    "banner_maliciousStrike": "Unanimous verdict against a repeated pattern — a major reliability penalty applies.",
    "title": "Dispute",
    "open": "Open dispute",
    "reason_label": "Reason for dispute",
    "submit": "Submit",
    "status": {
      "open": "Open",
      "resolved": "Resolved",
      "closed": "Closed"
    },
    "outcome": {
      "favor_creator": "In favour of creator",
      "favor_counterparty": "In favour of counterparty",
      "split": "Split",
      "dismissed": "Dismissed"
    },
    "action_respond": "Respond to Dispute",
    "action_manage": "Manage Dispute",
    "action_respondMutual": "Respond to Resolution Proposal",
    "mutualResolutionWaiting": "You proposed a mutual resolution. Waiting for the other party…",
    "banner_withdrawn": "The dispute was withdrawn — the agreement continues normally.",
    "banner_autoCancelled_title": "Auto-cancelled",
    "banner_autoCancelled_body": "The agreement was automatically cancelled due to an unresolved dispute.",
    "banner_resolvedAccepted_title": "Resolved",
    "banner_resolvedAccepted_body": "The dispute was resolved by mutual acceptance.",
    "banner_penaltyRespondent_title": "Dispute resolved",
    "banner_penaltyRespondent_body": "The respondent accepted responsibility.",
    "banner_bothSubmitted_initiator": "Both statements submitted. Awaiting admin review.",
    "banner_bothSubmitted_respondent": "Both statements submitted. Awaiting admin review.",
    "banner_waiting": "Statement submitted. The other party has until {{date}} to respond.",
    "banner_respondentWarning": "You have until {{date}} to respond, otherwise the dispute will be auto-resolved.",
    "banner_submittedWaiting": "Your statement was submitted. Waiting for the other party…",
    "open_step1_title": "Reason for dispute",
    "open_step1_body": "Select one or more reasons (hidden until the other party responds):",
    "open_step2_title": "Explanation (optional)",
    "open_step2_body": "Describe your disagreement with the other user in detail, without sharing sensitive details of the agreement. Explain why you're right and they're wrong. This will only be visible to the other party after they submit their own statement.",
    "open_step3_title": "Confirmation",
    "open_step3_body": "Read what happens when you submit:",
    "evidence_title": "Evidence (optional)",
    "evidence_body": "If you have relevant conversation in the agreement's chat, open it, take a screenshot and attach it here as evidence. It will only be visible to the other party after they submit their own statement too.",
    "evidence_openChat": "Open agreement chat",
    "evidence_addScreenshot": "Attach screenshot",
    "evidence_takePhoto": "Take a photo",
    "respond_title": "Dispute in progress",
    "respond_note_label": "Note:",
    "respond_note_body": "The other party's reasons are NOT visible yet — they will be revealed simultaneously when both parties have submitted.",
    "action_commDeclare": "I'll pursue resolution outside the app — +24h",
    "inAppMessagesNote": "Messages you've already exchanged in-app for this agreement are automatically part of the record.",
    "commDeclared": "Communication declared ✓",
    "action_acceptDispute": "I admit I'm at fault",
    "action_contestDispute": "I disagree — I want to respond",
    "action_decideLater": "Cancel (I'll decide later)",
    "accept_title": "Accepting the Dispute",
    "action_acceptPenalty": "I accept (−0.25★)",
    "myStatement_title": "Your statement",
    "myStatement_body": "Select reasons (won't be visible to the other party until both have submitted simultaneously):",
    "action_submitStatement": "Submit Statement",
    "reveal_title": "Statement Reveal",
    "reveal_body": "Both parties have submitted. Reasons are now revealed simultaneously.",
    "reveal_myReasons": "Your reasons:",
    "reveal_otherReasons": "{{name}}'s reasons:",
    "reveal_whatToDo": "What do you want to do?",
    "action_withdrawPenaltySmall": "Withdraw Dispute — unfreeze (−0.1★)",
    "action_persistPenalty": "Persist — cancellation with penalty (up to −0.5★)",
    "action_sendProposal": "Send proposal",
    "withdraw_title": "Withdraw Dispute",
    "persist_title": "Persist in Dispute",
    "action_persistFinal": "I persist (up to −0.5★)",
    "respondMutual_title": "Mutual Resolution Proposal",
    "action_acceptMutual": "I accept — cancellation without penalty",
    "action_rejectMutual": "I reject — dispute continues",
    "initiator_role": "Opened dispute",
    "banner_bothSubmitted": "Both parties have submitted statements. Tap 'Manage Dispute' to see the reasons and decide.",
    "banner_waitingOther": "Waiting for {{name}}'s response until {{date}}.",
    "banner_bothSubmittedWaiting": "Both have submitted. Waiting for {{name}}'s decision.",
    "banner_respondDeadline": "You have until {{date}}. If you don't respond, you lose 0.5★ automatically.",
    "banner_statementSubmitted": "Your statement was submitted. Waiting for {{name}}'s decision.",
    "errorGeneric": "Error.",
    "open_step2_placeholder": "e.g. The delivery wasn't made within the agreed deadline…",
    "open_step3_bullet_stake": "You'll be charged the 15-ink dispute filing fee. If you withdraw before the jury is drawn, it's refunded.",
    "open_step3_bullet_freeze": "The agreement freezes until resolution.",
    "open_step3_bullet_deadline": "The other party has 48 hours to respond.",
    "open_step3_bullet_accept": "If they accept fault → they lose 0.25★ and the agreement is cancelled.",
    "open_step3_bullet_contest": "If they disagree → the case goes to a random draw of 3-5 independent jurors. Whoever loses, loses rating.",
    "open_step3_bullet_withdraw": "In that case nobody loses rating either — withdrawing before the jury is drawn is the only \"no consequences\" option.",
    "submitCountdown": "Submit ({{count}})",
    "submitDispute": "Submit Dispute",
    "respond_body": "The other party reported a dispute. The agreement is frozen.\n\nYou have until {{date}} to respond. If you don't respond, you'll automatically lose 0.5★.",
    "respond_hintAccept": "You lose 0.25★, the agreement is cancelled — that's it.",
    "respond_hintContest": "If you persist → the case goes to a random draw of 3-5 independent jurors. Their verdict is final.",
    "accept_body": "If you accept the dispute:",
    "accept_bullet_rating": "Your rating decreases by 0.25★.",
    "accept_bullet_cancel": "The agreement is cancelled with no further consequences.",
    "myStatement_bullet_reveal": "Both parties' reasons are revealed as soon as you submit.",
    "myStatement_bullet_final": "Submission is FINAL: the dispute ends immediately in a deadlock.",
    "myStatement_bullet_stars": "Only whoever loses the jury's verdict loses rating (up to 0.5★). The complainant's filing fee (15 ink) is never refunded regardless of outcome — it always goes to the jurors.",
    "mutual_proposal": "You're sending {{name}} a proposal for a mutual resolution.",
    "mutual_deadline": "They have 48 hours to accept or reject.",
    "banner_waitingMutualDecision": "Now waiting for {{name}}'s decision too.",
    "mutual_deadline_until": "Deadline: {{date}}.",
    "mutual_accept": "If they accept → cancellation without penalty for anyone.",
    "mutual_reject": "If they reject/it expires → you return to your options.",
    "withdraw_unfreeze": "The agreement unfreezes and continues normally.",
    "withdraw_penalty": "Because you're withdrawing AFTER the reveal → -0.1★ on your rating.",
    "persist_loss": "{{name}} loses up to 0.5★ from their rating.",
    "persist_cancel": "The agreement is permanently cancelled.",
    "persist_record": "The results are recorded on both profiles.",
    "respondMutual_body": "{{name}} is proposing a mutual resolution to the dispute.",
    "respondMutual_accept": "If you accept → the agreement is cancelled mutually, nobody loses rating.",
    "respondMutual_reject": "If you reject → the dispute continues normally.",
    "respondMutual_deadline": "The proposal expires: {{date}}",
    "banner_autoCancelled_initiator": "The dispute expired automatically. {{name}} didn't respond within 5 days and lost 0.5★.",
    "banner_autoCancelled_respondent": "The dispute expired automatically. You didn't respond within 5 days — you lost 0.5★.",
    "banner_acceptedByRespondent_initiator": "{{name}} accepted the dispute (-0.25★). The agreement was cancelled.",
    "banner_acceptedByRespondent_self": "You accepted the dispute (-0.25★). The agreement was cancelled.",
    "banner_deadlock": "Your agreement's dispute ended in a deadlock. You lost {{myLoss}}★ and {{name}} lost {{otherLoss}}★. The agreement was cancelled.",
    "banner_penaltyRespondent_initiator": "You persisted — {{name}} lost 0.5★. The agreement was cancelled.",
    "banner_penaltyRespondent_respondent": "The other party persisted. You lost 0.5★.",
    "banner_frozenTitle": "⏸ Agreement frozen",
    "banner_pendingResponseTitle": "⚠ Your response is pending!"
  },
  "disputeOutcomeCard": {
    "outcomeLabel_accepted": "Admitted fault",
    "outcomeLabel_penaltyRespondent": "Persisted",
    "outcomeLabel_autoCancelled": "Auto-cancelled",
    "outcomeLabel_timeoutDefault": "Auto-expired",
    "outcomeLabel_baselessComplaint": "Baseless complaint",
    "outcomeLabel_juryVerdict": "Jury verdict",
    "juryFavorsBusiness": "The dispute was ruled in favor of the business",
    "juryFavorsClient": "The dispute was ruled in favor of the client",
    "outcomeLabel_adminReview": "Under admin review",
    "verdict_pendingAdmin": "Pending admin review",
    "outcomeLabel_default": "Dispute",
    "verdict_right": "Vindicated",
    "verdict_admitFault": "Admitted fault",
    "verdict_atFault": "Found at fault",
    "verdict_noResponse": "Did not respond",
    "verdict_baseless": "Baseless complaint",
    "verdict_withdrawn": "Withdrew the dispute",
    "verdict_mutual": "Mutual resolution",
    "verdict_deadlock": "No resolution found",
    "defaultUser": "User",
    "defaultAgreement": "Agreement",
    "respondentRole_admitted": "Admitted",
    "respondentRole_noResponse": "Did not respond",
    "respondentRole_responded": "Responded"
  },
  "announcements": {
    "published": "Published!",
    "freeBanner": "Publishing an announcement is free. Mobile push notification costs 1 ink.",
    "field_text": "Announcement text",
    "field_image": "Image (optional)",
    "action_pickImage": "Select image",
    "push_limit": "Maximum 1 per 7 days",
    "push_availableAt": "Available again on {{date}}",
    "freeCooldownUntil": "You'll be able to post again on {{date}}.",
    "action_publish": "Publish",
    "requiresProfessional": "You need an active Professional Account to publish an announcement.",
    "requiresProfessionalShort": "You need an active Professional Account.",
    "field_text_placeholder": "Write a short announcement for your circle…",
    "push_label": "Push notification (1 ink)",
    "success_body": "Your announcement has been sent to your contacts.",
    "success_body_push_suffix": " A push notification was also sent.",
    "error_writeText": "Write something.",
    "error_cooldown": "You can post again in {{hours}} hours.",
    "error_paid_cooldown": "You can send a paid push notification only once every 7 days."
  },
  "disputeOutcome": {
    "accepted": "Voluntary acceptance",
    "persisted": "Persisted",
    "autoCancelled": "Auto-cancelled",
    "default": "Dispute",
    "openedDispute": "Opened dispute",
    "responded": "Responded"
  },
  "payments": {
    "title": "Payments",
    "subtitle": "Agreement fees (1 ink per signature)",
    "walletMethod": " · Wallet",
    "empty_title": "No payments yet",
    "empty_body": "Your payment history will appear here.",
    "agreement_fallback": "Agreement"
  },
  "receipt": {
    "label": "Receipt",
    "notFound": "Receipt not found.",
    "wallet": "Wallet",
    "field_number": "Number",
    "field_date": "Date",
    "field_agreement": "Agreement",
    "field_method": "Method",
    "field_orderCode": "Order code",
    "field_transactionCode": "Transaction code",
    "note_wallet": "Ink deducted from your pen balance.",
    "note_viva": "Processed via Viva Wallet.",
    "action_share": "Share receipt",
    "share_header": "Heirapsia — Receipt",
    "share_status": "Status: {{status}}",
    "share_amount": "Amount: {{amount}}",
    "share_date": "Date: {{date}}",
    "share_agreement": "Agreement: {{title}}",
    "share_method": "Method: Wallet",
    "share_order": "Order code: {{code}}",
    "share_transaction": "Transaction code: {{code}}",
    "share_fee": "Platform fee"
  },
  "search": {
    "title": "Search",
    "field_label": "Name or UserID",
    "hint": "Enter at least 2 characters (name or UserID).",
    "noResults": "No user found with that name.",
    "suggestions": "Did you mean one of these?"
  },
  "user": {
    "deletedMember": "No longer a Heirapsia member",
    "knownAs": "Also known as: {{nickname}}",
    "memberSince": "Member since",
    "visitEshop": "🛍️ Visit the eShop",
    "openInMaps": "📍 Open in maps",
    "completed": "completed",
    "commonAgreements": "Common Agreements",
    "professionalProfile": "Professional Profile",
    "requestQuoteGeneral": "Request a Quote",
    "responsiblePerson": "Owner: {{name}}",
    "announcement": "Announcement",
    "expiresIn_one": "Expires in 1 day",
    "expiresIn_other": "Expires in {{count}} days",
    "error_sendRequest": "Could not send connection request.",
    "error_response": "Response failed.",
    "error_remove": "Could not remove.",
    "shareTitle": "{{name}} on Heirapsia",
    "shareMessage": "Check out {{name}}'s profile on Heirapsia\n{{url}}",
    "unusualDisputeWinRate": "Unusually high dispute win rate",
    "searchFailed": "Search failed.",
    "portfolioPreviewBanner": "Preview — the portfolio isn't active yet. Enable it from your Profile.",
    "verifiedIdentity": "Verified identity"
  },
  "portfolio": {
    "stat_completed": "Completed",
    "stat_success": "Success rate",
    "stat_rating": "Rating",
    "businessMembers": "Business partners",
    "businessMemberViewing": "viewing",
    "businessHiddenMembers_one": "and {{count}} more partner (private profile)",
    "businessHiddenMembers_other": "and {{count}} more partners (private profiles)",
    "completedAgreements": "Completed Agreements",
    "paymentMethodsDisclaimer": "Informational only — payment happens directly between you, outside the app. Heirapsia doesn't act as an intermediary.",
    "paymentMethodsShow": "Tap to see payment methods",
    "openLink": "Open link →",
    "noAccount": "No professional account available.",
    "noCompletedAgreements": "No completed agreements yet.",
    "resolvedDispute": "Resolved via dispute"
  },
  "connection": {
    "inCircle": "In your circle",
    "addedYou": "Added you to their circle",
    "pending": "Request pending",
    "action_add": "Add to my circle",
    "action_remove": "Remove"
  },
  "freeze": {
    "suspended": "Your account has been permanently suspended. Contact hello@heirapsia.gr",
    "frozen": "Temporarily suspended until {{until}}. Creating and accepting agreements is disabled."
  },
  "update": {
    "title_forced": "Update required",
    "title_available": "New version available",
    "body_forced": "Please update the app to continue using Heirapsia.",
    "body_available": "A new version of Heirapsia is available.",
    "action_now": "Update now",
    "action_later": "Later"
  },
  "consent": {
    "text": "We use essential cookies to operate the service. See our",
    "privacyLink": "Privacy Policy",
    "ok": "OK"
  },
  "invite": {
    "notFound": "Invitation not found or has expired.",
    "loadError": "Could not load invitation.",
    "tagline": "Professional agreements, digitally.",
    "action_registerAndSign": "Register & Sign",
    "action_registerAndAccept": "Register & Accept",
    "agreement_title": "Agreement Invitation",
    "agreement_header": "Agreement Invitation",
    "youLabel": "You",
    "agreement_body": "You've been invited to sign a Heirapsia agreement.",
    "agreement_notFound": "Agreement not found.",
    "agreement_loadError": "Could not load agreement.",
    "agreement_loginPrompt": "Sign in or create a Heirapsia account to accept this agreement.",
    "offer_header": "Professional Offer",
    "offer_notFound": "Offer not found or has expired.",
    "offer_acceptError": "Could not accept offer.",
    "offer_loadError": "Could not load offer.",
    "offer_accepting": "Accepting offer…",
    "offer_acceptPrompt": "Accept the offer to automatically create a Heirapsia agreement.",
    "offer_codePrompt": "To view this offer, enter the 6-digit code that was sent to you along with the link.",
    "offer_codePlaceholder": "6-digit code",
    "offer_codeSubmit": "Continue",
    "offer_codeInvalid": "Wrong code. Try again.",
    "offer_codeTooManyAttempts": "Too many wrong attempts. Ask the sender to resend the offer.",
    "offer_codeRequired": "A code is required.",
    "professionalTerms": "{{name}} Terms & Conditions",
    "have_account": "Already have an account?",
    "agreement_inviteText": "invites you to sign this agreement.\nSign up to continue."
  },
  "onboarding": {
    "title": "Tell us about yourself",
    "subtitle": "Complete your profile to get started.",
    "continue": "Continue"
  },
  "reviewSummary": {
    "disputedLossBadge": "⚠️ This reviewer lost a dispute against this user — reduced weight in the average",
    "characterization_excellent": "Excellent partner",
    "characterization_reliable": "Reliable partner",
    "characterization_pleasant": "Pleasant to work with",
    "characterization_new": "New member",
    "reliability_known": "Reliability score",
    "reliability_unknown": "Reliability unknown",
    "reviewerReliability": "({{percent}}% reliability)",
    "uniqueUsers_one": "from {{count}} user",
    "uniqueUsers_other": "from {{count}} users",
    "noReviews": "No reviews yet",
    "tapForMore": "Tap for more ℹ",
    "toggle_hide": "Hide reviews",
    "toggle_show": "Show detailed reviews",
    "stat_completed": "Completed",
    "stat_mutualCancellations": "Mutual cancellations",
    "stat_unilateralCancellations": "Unilateral cancellations",
    "stat_disputes": "Disputes",
    "disputeResults": "Dispute outcomes",
    "emptyFilter": "No reviews in this category.",
    "capHint_id": "Verify identity for {{target}}%",
    "ok": "OK",
    "info_reliability": "Reliability Score 🏆",
    "info_disputes": "Disputes",
    "capHint_fewAgreements": "Complete more agreements for higher reliability",
    "capHint_lowRating": "Improve your reviews for higher reliability",
    "reliability_info_body": "RELIABILITY SCORE\nShows how reliable the user is at completing their agreements.\n\n✅ Increases when an agreement is completed successfully by both sides.\n\n❌ Decreases when the user unilaterally cancels an active agreement.\n\n➖ Not affected by mutual cancellations — if both sides agree to cancel, the score doesn't change.\n\n⭐ STARS\nShow how satisfied others were with working with them (quality of work, consistency, behaviour) — rated after each agreement. Only the most recent rating from each user counts, so it can't be artificially inflated with repeated agreements with the same person.\n\n🔗 THE RELATIONSHIP\nFrom 5 different users onward, a consistently low average rating caps the reliability score — so someone who never formally cancels but does sloppy work or doesn't respect the terms doesn't look flawless.\n\n📊 FEW AGREEMENTS\nWith few completed agreements the score can't reach 100% even if they all went well — a longer history is needed to prove consistent reliability.",
    "reliability_info_body_noData": "The reliability score is unknown because the user hasn't made any agreements on Heirapsia yet.",
    "disputes_info_body": "How many disputes the user has opened relative to their number of agreements.",
    "stat_completed_info": "Agreements that were successfully completed and confirmed by both sides.",
    "stat_unilateral_info": "Agreements they cancelled unilaterally, without the other party's agreement — negatively affects the reliability score.",
    "unilateral_veryFrequent": "Cancels unilaterally very often",
    "unilateral_frequent": "Cancels unilaterally often",
    "unilateral_sometimes": "Cancelled unilaterally a few times",
    "unilateral_rare": "Rarely cancelled unilaterally",
    "disputes_everyOther": "Disputes every 2nd agreement",
    "disputes_veryFrequent": "Disputes very often",
    "disputes_quiteFrequent": "Disputes quite often",
    "disputes_frequent": "Disputes often",
    "disputes_sometimes": "Disputes sometimes",
    "disputes_rare": "Rarely disputes",
    "disputes_minimal": "Rarely disputes",
    "filter_completed": "Reviews from completed agreements",
    "filter_mutual": "Reviews from mutual cancellations",
    "filter_unilateral": "Reviews from unilateral cancellations"
  },
  "notification_push": {
    "completionRequested_title": "🏁 Completion request",
    "completionRequested_body": "«{{title}}» — do you confirm?",
    "pendingSignature_title": "✍️ Your signature is pending",
    "pendingSignature_body": "«{{title}}»",
    "cancelRequested_title": "⚠️ Cancellation request",
    "cancelRequested_body": "{{name}} requests cancellation of «{{title}}»",
    "paymentDeclared_title": "💰 Payment declared",
    "paymentDeclared_body": "{{name}} declared payment for «{{title}}»",
    "connectionRequest_title": "🤝 Connection request",
    "connectionRequest_body": "{{name}} wants to connect with you",
    "newOffer_title": "📋 New offer for you",
    "newOffer_body": "{{name}} sent you an offer: «{{title}}»",
    "openDispute_title": "🚨 Open dispute",
    "openDispute_body": "{{name}} opened a dispute on «{{title}}»"
  },
  "professionals": {
    "tab_browse": "Professionals",
    "tab_requests": "Job Requests"
  },
  "requests": {
    "title": "Requests",
    "subtitle": "Ask for what you need and get offers from professionals.",
    "subtitleForProfessionals": "See all client requests and submit your own offer!",
    "demandInRegion": "There's demand in your field, in your region!",
    "demandRemote": "There's remote demand in your field!",
    "filter_open": "Looking for offers",
    "filter_mine": "My request",
    "emptyOpen": "No open requests right now.",
    "ownTag": "Yours",
    "remoteTag": "Remote",
    "emptyMine": "You haven't posted any requests yet.",
    "onlyProfessionalsSeeOpen": "Available jobs are only visible to professionals. Here you see your own requests.",
    "status_closed": "Closed",
    "status_cancelled": "Cancelled",
    "newTitle": "New request",
    "newSubtitle": "Describe what you need — professionals will send you offers.",
    "editTitle": "Edit request",
    "editSubtitle": "You can change the details while the request is still open.",
    "action_edit": "Edit",
    "directTitle": "Request a Quote",
    "directSubtitle": "Describe what you need — it will be sent directly to {{name}}, not to the public request board.",
    "action_sendDirect": "Send request",
    "field_imageOptional": "Photo (optional)",
    "action_addImage": "Add photo",
    "imageSourceCamera": "Take photo",
    "imageSourceLibrary": "Choose from library",
    "imageHint": "Helps the professional understand what you need. Automatically deleted once the request closes.",
    "errorImageFailed": "The photo could not be uploaded. Try again.",
    "field_title": "Title",
    "placeholder_title": "e.g. Looking for a graphic designer",
    "field_description": "Description",
    "placeholder_description": "Add details...",
    "field_category": "Category",
    "field_regionOptional": "Professionals from region:",
    "regionAll": "All",
    "action_publish": "Publish",
    "postedSuccess": "Posted successfully!",
    "action_sendOffer": "Send an offer",
    "action_cancelRequest": "Cancel request",
    "cancelTitle": "Cancel request",
    "cancelBody": "Are you sure you want to cancel this request?",
    "viewIncomingOffers": "View your incoming offers",
    "offersReceived": "Offers received ({{count}})",
    "noOffersYet": "You haven't received any offers for this request yet.",
    "notFound": "Not found.",
    "errorTitleRequired": "Title is required.",
    "errorCategoryRequired": "Category is required.",
    "errorCreateFailed": "Something went wrong."
  },
  "services": {
    "sectionTitle": "Services",
    "hint": "List of services with prices that clients will see on your public profile.",
    "action_add": "Add service",
    "addTitle": "New service",
    "editTitle": "Edit service",
    "placeholder_title": "Service title",
    "placeholder_description": "Description (optional)",
    "placeholder_price": "Price in € (optional)",
    "unit_fixed": "Fixed",
    "unit_hourly": "Per hour",
    "unit_per_item": "Per item",
    "unit_per_meter": "Per m",
    "unit_per_sqm": "Per m²",
    "inactive": "Inactive",
    "action_deactivate": "Hide from profile",
    "action_activate": "Reactivate",
    "deleteTitle": "Delete service",
    "deleteBody": "Permanently delete the service \"{{title}}\"?",
    "errorTitleRequired": "Title is required.",
    "errorInvalidPrice": "Invalid price.",
    "errorMaxReached": "You've reached the limit of 30 services.",
    "errorSaveFailed": "Save failed.",
    "requestQuote": "Request a quote"
  },
  "advancePayment": {
    "sectionTitle": "Advance Payment / Instalments",
    "totalAmount": "Total amount",
    "advance": "Advance payment",
    "remaining": "Remaining",
    "fullyPaid": "✓ Fully paid",
    "amountExceedsRemaining": "The advance payment cannot exceed the remaining balance ({{amount}}).",
    "errorRecordFailed": "Recording failed.",
    "errorActionFailed": "The action failed.",
    "errorLoadFailed": "Failed to load advance payments. Please try again.",
    "pendingMine": "You recorded an advance payment of {{amount}}. Waiting for {{name}}'s response…",
    "pendingOther": "{{name}} recorded an advance payment of {{amount}}. Remaining: {{remaining}}. Do you agree?",
    "confirmYes": "Yes",
    "confirmNo": "No",
    "rejectedNotice": "Your advance payment ({{amount}}) was rejected and doesn't count toward the agreement.",
    "action_add": "Note an Instalment Amount",
    "action_declarePayment": "Note Full Payment",
    "modalTitle": "Record advance payment / instalment",
    "modalHint": "Remaining available: {{amount}}",
    "recordOnlyDisclaimer": "⚠️ This is just a note/record — Heirapsia does not transfer any money. Payment happens outside the app, however you've agreed.",
    "placeholder_amount": "Amount (€)",
    "placeholder_note": "Note (e.g. Paid in cash)",
    "action_record": "Record"
  },
  "renewal": {
    "waitingTitle": "Awaiting renewal",
    "youAccepted": "You accepted renewal. Waiting for the other party.",
    "youDeclined": "You declined renewal. The agreement is being completed.",
    "otherDeclined": "The other party declined — the agreement is being completed.",
    "promptTitle": "Renew agreement?",
    "promptBody": "The agreement has ended. Do you want to continue with the same duration?",
    "otherAccepted": "The other party already accepted.",
    "action_yes": "Yes, renew",
    "action_no": "No"
  },

  "reviewTags": {
    "professional": "Professionalism",
    "fast_delivery": "Fast delivery",
    "honest": "Honest",
    "good_communication": "Good communication",
    "kept_terms": "Kept to obligations",
    "friendly": "Friendly",
    "precise": "Precise with details",
    "reliable": "Reliable",
    "highly_recommended": "Highly recommended",
    "slow_delivery": "Slow delivery",
    "bad_communication": "Poor communication",
    "no_delivery": "Didn't deliver as agreed",
    "delay_no_notice": "Delay without notice",
    "unprofessional_behavior": "Unprofessional behavior",
    "unreliable": "Unreliable",
    "different_from_agreed": "Different from what was agreed",
    "not_recommended": "Not recommended",
    "punctual": "Punctual",
    "straightforward": "Straightforward",
    "cooperative": "Cooperative",
    "late": "Was late",
    "broke_terms": "Broke the terms",
    "no_phone_response": "Doesn't answer the phone"
  },

  "mobileWebBanner": {
    "message": "Download the app for easier interaction!",
    "action": "Get it"
  },

  "chatBubble": {
    "callLabel": "Call",
    "communicationAccessibilityLabel": "Communication",
    "sheetTitle": "Communication",
    "sheetTitleFor": "You're viewing the available ways to contact {{name}}.",
    "pickPersonTitle": "Who do you want to contact?",
    "inAppOption": "Communicate within Χειραψία",
    "recommendedBadge": "Recommended",
    "externalOption": "Communicate outside",
    "inAppUnavailableHint": "Available only on active agreements",
    "closeAccessibilityLabel": "Close",
    "moveToOtherSide": "Move to the other side",
    "inlineButtonLabel": "Contact"
  },

  "level2ReviewModal": {
    "suggestSubject": "Feature suggestion - Heirapsia"
  },

  "professionReminderModal": {
    "title": "You haven't set a profession",
    "body": "Your professional account is active, but without a set profession you won't show up correctly in searches and client matches.",
    "action": "Set profession"
  },

  "tutorial": {
    "skip": "Skip",
    "next": "Next",
    "start": "Get started!",
    "slide1_title": "Digital agreements",
    "slide1_text": "No more \"I told you that\", \"I understood something else\", etc. Make agreements with anyone digitally — because writing… lasts! And stays between you two! Nobody has access to the content of your agreement.",
    "slide2_title": "Free to create",
    "slide2_text": "Creating and sending is free. You're only charged 1 ink each once you both agree. And to get you started, we're giving you 45 free agreements and 15 ink to try it out!",
    "slide3_title": "You agree & sign",
    "slide3_text": "When you both tap 'I Agree', the agreement becomes active. You can download the PDF document — and print it like a classic agreement!",
    "slide4_title": "Your signature pen",
    "slide4_text": "Every time you sign an agreement, your pen loses a bit of ink! You start with 45 free signatures (enough for the whole \"New\" tier) and 15 ink as a gift. Once they run out, you buy ink from within the app.",
    "slide5_title": "Trust & ratings",
    "slide5_text": "After each agreement you rate each other. Build your reputation, earn the 'Verified' badge and become the user everyone wants to work with!",
    "slide6_title": "How Heirapsia works",
    "slide6_text": "① You create an agreement → the other party accepts → it starts.\n② After completion you rate each other with tags.\n③ If there's a problem → 'Report Dispute'.\n④ Each side selects reasons separately and privately.\n⑤ When both have submitted → they're revealed simultaneously.\n⑥ Honesty is rewarded — a smaller penalty if you admit fault."
  },

  "portfolioTutorial": {
    "skip": "Skip",
    "next": "Next →",
    "start": "Get started! Create an offer →",
    "slide1_title": "Professional Account",
    "slide1_body": "The Professional Account is your professional identity on Heirapsia. By activating it you get:\n\n• A 'Service Provider' badge\n• The ability to send professional offers\n• A public portfolio page with reviews\n• A professional profile for clients",
    "slide2_title": "How to create an offer",
    "slide2_body": "Create an offer in a few steps:",
    "slide2_mock": "📋 Title: \"Website build\"\n💬 Description: Landing page + SEO optimisation\n💶 Cost: €800\n⏱ Delivery: 14 days\n📧 Client email (optional)",
    "slide3_title": "Send a link or email",
    "slide3_body": "After creating it you have two options:\n\n🔗 Copy / Share link — send it yourself via WhatsApp, Viber, SMS, etc.\n\n✉️ Email — type the client's email and it's sent automatically",
    "slide4_title": "What the client sees",
    "slide4_body": "The client opens the link and sees a preview of the offer:\n\n• Job title & description\n• Cost & delivery time\n• Your profile\n\nBy tapping 'Accept', they sign for free and a Heirapsia agreement is created automatically.",
    "slide5_title": "You sign last",
    "slide5_body": "Once the client signs, you get a push notification:\n\n\"The client signed! Sign to activate.\"\n\nYou open the agreement and sign. Then:\n\n💶 You're charged 1 ink\n📄 A digital agreement with a PDF is created\n✅ The agreement becomes active"
  },

  "circleTutorial": {
    "skip": "Skip",
    "next": "Next",
    "gotIt": "Got it!",
    "slide1_title": "Welcome to your Circle!",
    "slide1_body": "Here you have direct access to all your contacts — the people you've connected with.",
    "slide2_title": "Network of connections",
    "slide2_body": "If two of your contacts already know each other, you'll see them connected with a dashed line in the graph.",
    "slide3_title": "Privacy",
    "slide3_body": "If a Professional Account isn't public, only people in their circle can see it.",
    "slide4_title": "Announcements",
    "slide4_body": "If you're a Professional, you can send an announcement to all your contacts — for free! For 1 ink you can also send them a push notification.",
    "slide5_title": "Your Circle is your power!",
    "slide5_body": "Build trusted relationships, grow your network and discover collaboration opportunities."
  },

  "coachmarks": {
    "skip": "Skip",
    "next": "Next",
    "done": "Done"
  },

  "howItWorks": {
    "back": "‹ Back",
    "title": "How it works",
    "intro": "Heirapsia is a digital agreements platform between private individuals, with a built-in dispute resolution system.",
    "step1_title": "Create & send",
    "step1_text": "You create an agreement with a title, type, amount and terms. You send it to the other party.",
    "step2_title": "Mutual acceptance",
    "step2_text": "When both of you tap 'I Agree & Sign', the agreement becomes active and is signed digitally.",
    "step3_title": "Review after completion",
    "step3_text": "After completion, you rate each other with tags (Punctual, Honest, Straightforward). The rating shows on the profile.",
    "step4_title": "Report a Dispute",
    "step4_text": "If there's a problem in an active agreement, you can open a Dispute. The agreement freezes until it's resolved.",
    "step5_title": "Hidden statements",
    "step5_text": "Each party selects their reasons separately and privately. The other party doesn't see your tags until they've also submitted.",
    "step6_title": "Simultaneous reveal",
    "step6_text": "When both parties submit a statement, the reasons are revealed simultaneously. The initiator then decides whether to withdraw or persist.",
    "step7_title": "Honesty is rewarded",
    "step7_text": "If you accept the dispute you only lose 0.25★. If you persist without a fair reason, you lose 0.5★. Honesty costs less.",
    "step8_title": "Results are recorded",
    "step8_text": "Every dispute and its outcome are recorded on both parties' profiles for full transparency."
  },

  "dataScreen": {
    "back": "‹ Back",
    "title": "My data",
    "exportTitle": "Data export",
    "exportText": "Download all your personal data in JSON format (GDPR data portability right).",
    "action_downloadJson": "Download JSON",
    "action_exportShare": "Export & share",
    "errorTitle": "Error",
    "errorExportFailed": "Export failed.",
    "errorDeleteFailed": "Deletion failed.",
    "storageNotice": "Your data is stored on servers within the EU (Frankfurt). You can request at any time",
    "deleteLinkText": "Account and data deletion",
    "deleteModalTitle": "Delete account",
    "deleteModalMessage": "This action is permanent and cannot be undone. The following will be deleted:",
    "deleteBullet1": "Your account and profile",
    "deleteBullet2": "The agreements you created",
    "deleteBullet3": "Your reviews and data",
    "deleteBullet4": "Your email will not be usable for a new registration in the future",
    "deleteConfirmLabel": "I'm sure"
  },

  "newsScreen": {
    "title": "Newspaper",
    "bookmarksTab": "Bookmarks",
    "pageOf": "Page {{page}} of {{total}}",
    "timeAgo_justNow": "just now",
    "timeAgo_hours": "{{count}}h ago",
    "timeAgo_days": "{{count}}d ago",
    "removeBookmark": "Remove bookmark",
    "saveBookmark": "Save",
    "openInBrowser": "Read it",
    "searchPlaceholder": "Search news…",
    "emptyBookmarks": "You haven't saved any news yet.",
    "emptySearch": "No results found for \"{{query}}\".",
    "emptyNews": "No news yet."
  },

  "verifyScreen": {
    "headerSub": "Agreement verification",
    "notFoundTitle": "Agreement not found",
    "notFoundBody": "This identifier doesn't correspond to a Heirapsia agreement.",
    "validTitle": "Valid agreement on Heirapsia",
    "field_title": "Title",
    "field_status": "Status",
    "field_type": "Type",
    "field_created": "Created",
    "type_oneOff": "One-off",
    "type_longTerm": "Long-term",
    "type_fixedTerm": "Fixed-term",
    "withdrewOn": "Withdrew on {{date}}",
    "sectionTitle_parties": "Parties",
    "bothSignedSeal": "✓ Digitally signed by both parties",
    "privacyNote": "For privacy reasons, the amount and terms of the agreement are not shown.",
    "action_openApp": "Open Heirapsia",
    "defaultUser": "User",
    "signedDigitally": "✔ Signed digitally",
    "pendingSignature": "Signature pending"
  },

  "phoneInput": {
    "country_gr": "Greece",
    "country_cy": "Cyprus",
    "country_al": "Albania",
    "country_bg": "Bulgaria",
    "country_ro": "Romania",
    "country_de": "Germany",
    "country_gb": "United Kingdom",
    "country_us": "USA / Canada",
    "country_fr": "France",
    "country_it": "Italy",
    "country_es": "Spain",
    "country_pt": "Portugal",
    "country_nl": "Netherlands",
    "country_be": "Belgium",
    "country_at": "Austria",
    "country_ch": "Switzerland",
    "country_se": "Sweden",
    "country_dk": "Denmark",
    "country_no": "Norway",
    "country_au": "Australia"
  },

  "disclaimerNote": {
    "title": "Χειραψία Disclaimer",
    "text": "Disclaimer: Heirapsia is a digital tool for recording agreements between private individuals. It does not provide legal, accounting or banking services. Recording of instalments, advance payments and payments is done solely for documentation purposes between the parties."
  },

  "updatePrompt": {
    "title_forced": "Update required",
    "title_ota": "New fixes/features available!",
    "title_optional": "New version available",
    "body_forced": "A new version of Heirapsia is mandatory. Please update the app to continue.",
    "body_ota": "Tap restart to apply.",
    "body_optional": "A new version is available. Update for the latest improvements and fixes.",
    "action_restart": "Restart now",
    "action_updateNow": "Update now",
    "action_later": "Later"
  },

  "professionalTermsOption": {
    "noTermsYet": "You haven't set your terms of service yet.",
    "action_addTerms": "Add your terms",
    "attachLabel": "Attach my terms of service",
    "attachSublabel": "Shows your terms on the agreement page and adds a cover page to the PDF with your business logo."
  },

  "legalScreen": {
    "back": "‹ Back"
  },

  "starRating": {
    "starsAccessibilityLabel": "{{count}} stars"
  },

  "userIdChip": {
    "copyAccessibilityLabel": "Copy UserID"
  },

  "confirmModal": {
    "cancelDefault": "Cancel action",
    "tagsLabelDefault": "Select a reason (at least one):"
  },

  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Connection problem. Check your internet.",
    "session_expired": "Session expired. Please sign in again.",
    "permission_denied": "You don't have permission for this action.",
    "not_found": "Not found.",
    "upload_failed": "Upload failed. Please try again.",
    "titleRequired": "Please enter a title for the agreement.",
    "counterpartyRequired": "Please enter a name or email for the counterparty.",
    "invalidAmount": "Invalid amount.",
    "invalidDays": "Invalid number of days.",
    "invalidEmail": "Invalid email.",
    "accountSuspended": "Your account is suspended.",
    "accountFrozen": "Your account is temporarily frozen.",
    "dailyLimit": "Daily agreement limit reached.",
    "selfAgreement": "You cannot create an agreement with yourself.",
    "selectAtLeastOneTag": "Please select at least one tag.",
    "cannotWithdrawSigned": "You cannot withdraw this agreement because the other party has already signed.",
    "ratingRequired": "Please select a rating from 1 to 5 stars.",
    "offerTitleRequired": "Please enter a title for the offer.",
    "passwordMismatch": "Passwords do not match.",
    "termsRequired": "You must accept the Terms of Service.",
    "invalidOtp": "Invalid or expired code.",
    "fieldRequired": "Please fill in {{field}}.",
    "fieldTooLong": "{{field}} cannot exceed 40 characters.",
    "lettersOnly": "Use only letters and hyphens.",
    "fieldTooShort": "{{field}} must be at least 2 characters.",
    "cooldown24h": "24-hour cooldown — you can send again: {{time}}"
  },
  "placeholder": {
    "agreementTitle": "e.g. Equipment rental",
    "nameOrEmail": "Name or email…",
    "counterpartyName": "Counterparty name (optional)",
    "agreementTerms": "Describe the terms…",
    "offerTitle": "e.g. Website development",
    "recipientSearch": "Client name or email…",
    "declineReason": "Briefly explain why…",
    "search": "Search…",
    "userSearch": "Name or HEI-00123…",
    "userSearchExampleName": "E.g. John Smith",
    "userSearchExampleId": "HEI-00123",
    "yourName": "Your name",
    "specialty": "e.g. Graphic designer",
    "firstName": "e.g. Maria",
    "lastName": "e.g. Papadopoulou",
    "otp": "6-digit code",
    "passwordNew": "At least 6 characters",
    "passwordConfirm": "Repeat the password",
    "password": "••••••••",
    "searchAgreements": "Search title or person…",
    "nameOrUserId": "Name or HEI-00123…",
    "phoneNumber": "Mobile number"
  },
  "hint": {
    "counterpartyNotification": "They'll receive a notification to sign.",
    "existsInApp": "Found on Heirapsia — tap to select",
    "emailInvite": "We'll send an invite link to this email.",
    "nameSearch": "Searching by name…",
    "milestone": "The agreement has a fixed completion date.",
    "noMilestone": "No fixed deadline — open duration.",
    "percentAgreement": "Revenue sharing between the two parties.",
    "eurAmount": "A fixed euro amount for this agreement.",
    "bothPartiesCommit": "Both parties commit to the terms above.",
    "sendAgreement": "Sending will notify the other party to sign.",
    "recipientSearch": "Search a Heirapsia user or enter an email."
  },
  "verifiedBadge": {
    "alert_title": "Verified user",
    "alert_body": "This user has verified their identity (ID photo, approved by Heirapsia) — the highest verification level.",
    "alert_title_phone": "Verified phone",
    "alert_body_phone": "This user has verified their phone number with an SMS code."
  },
  "providerBadge": {
    "alert_title": "Provides Services",
    "alert_body": "This user has enabled portfolio and offers services via Heirapsia."
  },
  "levelBadge": {
    "accessibilityLabel": "Level {{level}} {{title}}",
    "progressLabel": "{{completed}} / {{required}} agreements",
    "toNextLevel": "{{count}} more to Level {{next}}",
    "avgRating": "Avg. rating",
    "tier_new": "Newcomer",
    "tier_active": "Active",
    "tier_experienced": "Experienced",
    "tier_veteran": "Veteran",
    "tier_expert": "Expert",
    "tier_legend": "Legend"
  },
  "jury": {
    "title": "Jury Duty",
    "introAnonymous": "Cases are fully anonymous — you only see each side's stated reasons, never names.",
    "howToJudgeTitle": "How to judge a case",
    "howToJudgeBody": "Read both sides' stated reasons and their stats (completed agreements, unilateral cancellations, past disputes). Check the agreement's conversation below for real evidence. Vote based on who you believe is telling the truth — you don't need certainty, just who's more likely right.",
    "empty": "You have no pending cases to review right now.",
    "caseStake": "Case — {{amount}} ink filing fee (your share: {{share}})",
    "viewChat": "View the agreement's conversation",
    "chatModalTitle": "Agreement conversation (anonymous)",
    "chatEmpty": "There are no messages in this agreement.",
    "chatLoadError": "Could not load the conversation.",
    "chatSideInitiator": "User A",
    "chatSideAccused": "User B",
    "chatSideOther": "Other party",
    "chatReadByOther": "✓✓ Read by the other side",
    "chatUnreadByOther": "Not yet read by the other side",
    "deadline": "Deadline: {{date}}",
    "myDeadline": "You have until {{date}} to vote — otherwise another juror is randomly drawn in your place.",
    "initiatorSide": "User A",
    "accusedSide": "User B",
    "openedDisputeBadge": "Opened the dispute",
    "noStatement": "No statement",
    "statRating_one": "from {{count}} review",
    "statRating_other": "from {{count}} reviews",
    "statCompleted": "Completed",
    "statUnilateralCancel": "Unilateral cancellations",
    "statDisputesOpened": "Disputes opened",
    "statFlagged": "Unusual dispute win rate",
    "voteInitiator": "User A is right",
    "voteAccused": "User B is right",
    "confirmTitle": "Confirm vote",
    "confirmBody": "Your vote is final and cannot be changed. As soon as you vote, you immediately receive {{amount}} ink as a juror reward, regardless of the outcome.",
    "voteFailed": "Voting failed."
  },
  "levelUp": {
    "levelLabel": "Level {{level}}",
    "body": "Congrats! You leveled up\nand earned 5 free agreements!",
    "continue": "Continue"
  },
  "reviewModal": {
    "body": "Help us improve — rate us or suggest something new!"
  },
  "profileTour": {
    "step1_title": "Welcome to your profile!",
    "step1_text": "This is where your details live. Let's take a quick look.",
    "step2_title": "Photo & details",
    "step2_text": "Tap your photo to change it. Add a bio for more trust.",
    "step3_title": "Rating & UserID",
    "step3_text": "Your rating is built from reviews after each agreement. Your UserID (HEI-…) is what you give others to find you easily.",
    "sig_text": "Draw your signature with your finger. It will appear in agreements you sign. (Required step)",
    "save_continue": "Save & continue",
    "phone_text": "Optional: verify your number via SMS to get the «✓ Verified» badge and build more trust.",
    "verify_now": "Verify now"
  },
  "wizard": {
    "agreement_step1_title": "Agreement details",
    "agreement_step1_subtitle": "Who is the other party?",
    "agreement_step2_title": "Amount & Terms",
    "agreement_step2_subtitle": "Define the financial terms.",
    "agreement_step3_title": "Review",
    "agreement_step3_subtitle": "Check everything before sending.",
    "offer_step1_title": "Title & Recipient",
    "offer_step1_subtitle": "Who is this offer for?",
    "offer_step2_title": "Cost & Description",
    "offer_step2_subtitle": "Define your service.",
    "offer_step3_title": "Review",
    "offer_step3_subtitle": "Check before sending."
  },
  "adminScreen": {
    "noAccess": "You don't have access to this page.",
    "noAccessScreen": "You don't have access to this screen.",
    "loadFailed": "Failed to load.",
    "docOpenFailed": "Couldn't open the document.",
    "photoOpenFailed": "Couldn't open the photo.",
    "actionFailed": "The action failed.",
    "verificationsTitle": "Verifications",
    "manageAdminsLink": "🛡️ Manage Admins →",
    "feedbackLink": "💬 Bug reports →",
    "feedbackTitle": "Bug reports / Feedback",
    "feedbackFilter_new": "New",
    "feedbackFilter_read": "Read",
    "feedbackFilter_all": "All",
    "feedbackEmpty": "No messages.",
    "feedbackUnknownUser": "Unknown user",
    "feedbackHasScreenshot": "Has a screenshot",
    "feedbackMarkDone": "✓ Done",
    "feedbackDeleteTitle": "Delete",
    "feedbackDeleteBody": "Permanently delete this message? This can't be undone.",
    "feedbackActionFailed": "The action failed.",
    "chatReportsLink": "🚩 Chat reports →",
    "chatReportsTitle": "Chat Reports",
    "chatReportsFilter_pending": "Pending",
    "chatReportsFilter_reviewed": "Reviewed",
    "chatReportsEmpty": "No reports.",
    "chatReportsUsersLine": "{{reporter}} reported {{reported}}",
    "chatReportsReportedMessage": "Reported message",
    "chatReportsMessageDeleted": "(message no longer exists)",
    "chatReportsViewAgreement": "Open agreement",
    "chatReportsMarkReviewed": "✓ Reviewed",
    "chatReportsActionFailed": "The action failed.",
    "tabIdentity": "🎖️ Identity",
    "tabPhone": "📱 Phone",
    "tabHistory": "🕓 History",
    "emptyIdentity": "No pending identity verification requests. 🎉",
    "emptyPhone": "No pending phone verification requests. 🎉",
    "emptyHistory": "No verification history yet.",
    "auditAction_approved": "✅ Approved",
    "auditAction_rejected": "❌ Rejected",
    "auditAction_manual_grant": "🔧 Manual grant",
    "auditAction_manual_revoke": "🔧 Manual revoke",
    "auditBy": "By: {{name}}",
    "auditBySelf": "The user themself (self-service)",
    "defaultUser": "User",
    "nameFieldLabel": "Name (as it appears on the ID)",
    "nameFieldPlaceholder": "Full name",
    "nameFieldHint": "Correct if it differs from the ID photo — it will be locked on the user's profile upon approval.",
    "photoFront": "Front",
    "photoBack": "Back",
    "photoSelfie": "Selfie",
    "reviewed": "Reviewed ✓",
    "reject": "Reject ✗",
    "approve": "Approve",
    "rejectSimple": "Reject",
    "viewDocument": "View document",
    "docTypePassport": "Passport",
    "docTypeId": "ID card",
    "rejectModalTitle": "Rejection Reason",
    "rejectModalSubtitle": "Choose one or more reasons (optional):",
    "tagBlurry": "Blurry photo",
    "tagDark": "Dark photo",
    "tagInvalidDoc": "Invalid document",
    "manageAdminsTitle": "Manage Admins",
    "manageAdminsSubtitle": "Enter a user's User ID to grant or revoke access to the admin panel.",
    "userIdLabel": "User ID",
    "userIdPlaceholder": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    "grantAdmin": "Grant Admin",
    "revokeAdmin": "Revoke Admin",
    "confirmGrantTitle": "Grant admin",
    "confirmRevokeTitle": "Revoke admin",
    "confirmUserIdBody": "User ID:\n{{id}}",
    "setAdminFailed": "Failed",
    "adminGranted": "✓ Admin granted",
    "adminRevoked": "✓ Admin revoked",
    "tipTitle": "Where do I find the User ID?",
    "tipBody": "In the Supabase Dashboard → Authentication → Users → click the user → the UUID at the top.\n\nOr in the app, in the user's settings if you have access to their profile."
  },

  "checkin": {
    "action": "Check in",
    "doneToday": "Checked in today",
    "rewarded": "🎉 You earned 1 ink!",
    "hint": "Every 7 days in a row earns you 1 ink.",
    "progressDone_zero": "Streak going — 7 more days for the next ink.",
    "progressDone_one": "One more day for 1 ink.",
    "progressDone_other": "{{count}} more days for 1 ink."
  }
}
